import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Tabs, Toast } from 'antd-mobile/lib';
import NavigatorMain from '../../NavigatorMain';
import headerImg from '../../../imgs/headerImg.png'
import fundHeader from '../../../imgs/fundHeader.png'
import yingxiao from '../../../imgs/yingxiao.png'
import { hashHistory } from 'react-router';
import "zrender/lib/svg/svg";
import echarts from "echarts/lib/echarts";
import "echarts/lib/component/legend";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import FundAnalysisTips from '../tip/FundAnalysisTips'
import { ClassfundFun } from '../../../common'
import { getDateS,getOneMonthBefor,compareTime, get3MonthBefor, get1yearBefor,get3yearBefor,get5yearBefor,Fromthisyear, getSixMonthBefor,dateDeath } from '../../../getPay'
import { newgetPublicProductDetil, getPublicHistoryProfileRate, Newpublicinterface,Newpublicinterfacedadian, getVersion, getVersionInfo, getFundAnalysisIndicatorOfFiveYears } from '../../../action/productAction'
import Util from '../../../util'
const TabPane = Tabs.TabPane;
const newToFixed = Util.newToFixed;
class NewPublicOffering extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key:'1',
      loadingFlag: true,
      initialPage: 0,
      is_optional: '0',
      tipIntroduce:false,
      dataSource:null,
      AddZxFlag: "",
      isTaxDeferredProduct: "0",//“1”个税产品“0”非个税产品
      AccumulatedNet:[],
      selectOther:false,
      tabtext:"",
      tabtextList:[],
      arr:[],
      text:"近一年",
      investflag:false,
      sum:0,
      invest:null,
      tebflag:false,
      beginDate:getOneMonthBefor(),
      endDate:"",

      buyDateList: [],//净值打点
      redeemDateList: [],
      
      newbuyDateList: [],//新版折线图收益走势 买入点
      newredeemDateList: [],//卖出
      dividendDateList:[],//分红

      profitNav: null,
      profitData: null,
      allIncome:null,
      Lineval:null,
      newDatas: null,
      newNevs: null,
      newNev:null,
      newData:null,
      tabVal: null,
      selectTab: '近1年',
      syArr: {
        zxjz: "--",
        rzdf: "--",
        wfsy: "--",
        qrnh: "--"
      },
      lineOption1:null,
      threeMonthDate: [],
      threeMonthNav: [],
      totalNav: [],
      totalDate: [],
      thisyearDate:[],//今年以来
      thisyearNav:[],
      ThreeYearDate:[],//三年
      ThreeYearNav:[],
      fiveYearDate:[],//五年
      fiveYearNav:[],
      oneYearDate: [],
      oneYearNav: [],
      oneMonthDate: [],
      oneMonthNav: [],
      sixMonthDate: [],
      sixMonthNav: [],
      echartsData: null,
      chartsDataArr: { //折线图
        oneMonth: [],
        oneMonthpublicFundflag:false,
        threeMonth: [],
        threeMonthpublicFundflag:false,
        sixMonth: [],
        sixMonthpublicFundflag:false,
        oneYear: [],
        oneYearpublicFundflag:false,
        thisyear:[],
        thisyearpublicFundflag:false,
        ThreeYear:[],
        ThreeYearpublicFundflag:false,
        fiveYear:[],
        fiveYearpublicFundflag:false,
        allData: [],
        allDatapublicFundflag:false,
      },

      Basictext:"沪深300",//指数基本信息
      symbolcode:"000300",
      Basicfalg:false,
      DataArr: [],//指数和折线图对比数据源
      icatorFlag:false,//是否展示基金指数
      dataInfo:null,
      Netperformance:null,
      buyTradeRule:null,
      PublicDetilBaseInfo:null,
      PublicDetilManager:null,
      latestDividend:null,
      latestPublicFundAnnouncement:null,
      acRelationFundCode:null,
      fundCode:'',
      chenck:false,
      chencked:false,
      dividDateList:[],//分红
      relationFundName:null,
      publicFundPerformanceflag:false,//是否只有本基金
      jumpToAPP:false,
      download_scheme:'',
      type:"m1",
      publicFundPerformanceResponseList:null,
      publicFundBenchmarkPerformanceResponseList:null,
      indexPerformanceResponseList:null,
      maxDrawDownArr: { //折线图最大回撤
        OneMonthmaxDrawDownValue:null,
        ThreeMonthmaxDrawDownValue:null,
        SixMonthmaxDrawDownValue:null,
        OneYearmaxDrawDownValue:null,
        ThisyearmaxDrawDownValue:null,
        ThreeYearmaxDrawDownValue:null,
        FiveYearmaxDrawDownValue:null,
        AllDatamaxDrawDownValue:null,
      },
      OneMonthBasicffsa:true,
      ThreeMonthBasicffsa:true,
      SixMonthBasicffsa:true,
      OneYearBasicffsa:true,
      ThisyearBasicffsa:true,
      ThreeYearBasicffsa:true,
      FiveYearBasicffsa:true,
      AllDataBasicffsa:true,
      Basicdata:[
        {symbolCode: '000905', symbolName: '中证500', exchangeName: 'XSHG'},
        {symbolCode: '399005', symbolName: '中小板', exchangeName: 'XSHE'},
        {symbolCode: '399006', symbolName: '创业板', exchangeName: 'XSHE'},
        {symbolCode: '000300', symbolName: '沪深300', exchangeName: 'XSHG'},
        {symbolCode: '000016', symbolName: '上证50', exchangeName: 'XSHG'},
        {symbolCode: '399001', symbolName: '深证指数', exchangeName: 'XSHE'},
        {symbolCode: '000001', symbolName: '上证指数', exchangeName: 'XSHG'}],
      discountRateHundredPercent:'',
      maxBuyRateHundredPercent:'',
      maxDrawDownValue:null,
      chengli:null,
      Notenoughforoneyear:1,
    }
    this.scrollView = null;
    this.androidUrl='';
    this.arr = []
  }
  getVersionCallBack=(data=1)=>{
    console.log(data);
  }
 //获取操作系统的名称和版本
  getOperatingSystem = () => {
    const userAgent = navigator.userAgent.toLowerCase();
  
    let osName = '';
    let osVersion = '';
  
    if (userAgent.indexOf('win') !== -1) {
      osName = 'Windows';
      const match = /Windows NT ([\d.]+)/.exec(userAgent);
      if (match) {
        osVersion = match[1];
      }
    } else if (userAgent.indexOf('mac') !== -1) {
      osName = 'Mac OS';
      const match = /Mac OS X ([\d_]+)/.exec(userAgent);
      if (match) {
        osVersion = match[1].replace(/_/g, '.');
      }
    } else if (userAgent.indexOf('x11') !== -1 || userAgent.indexOf('linux') !== -1) {
      osName = 'Linux';
    } else if (userAgent.indexOf('android') !== -1) {
      osName = 'Android';
      const match = /Android ([\d.]+)/.exec(userAgent);
      if (match) {
        osVersion = match[1];
      }
    } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1 || userAgent.indexOf('ipod') !== -1) {
      osName = 'iOS';
      const match = /(iPhone|iPod|iPad).*OS (\d+)/.exec(userAgent);
      if (match) {
        osVersion = match[2].replace(/_/g, '.');
      }
    } else {
      osName = 'Unknown';
    }
  
    return { osName, osVersion };
  };
  //获取设备类型
  getDeviceType=() =>{
    const userAgent = navigator.userAgent;
    
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return "iphone";
    } else if (/Android/i.test(userAgent)) {
      return "android";
    } else {
      return "unknown"; // 或者你可以返回其他适当的默认值
    }
  }
  
  
  componentDidMount(){
    let { dispatch} = this.props;
   
    let fundcode = this.props.location.query.fundcode?this.props.location.query.fundcode:'000948'
    Toast.loading('',0)
    dispatch(newgetPublicProductDetil(fundcode,this.handleCallback.bind(this),this));

		const userAgent = navigator.userAgent;
    console.log(userAgent);
    const versionIndex = userAgent.indexOf('Version/');
    let appVersion = '';
    if (versionIndex !== -1) {
      appVersion = userAgent.substr(versionIndex + 8).split(' ')[0];
    }
    console.log('***********appVersion*****************',appVersion);

    const osInfo = this.getOperatingSystem();
    const osver = osInfo.osName + ' ' + osInfo.osVersion; 
    console.log('Operating System:', osver);
    const deviceType = this.getDeviceType();

    let params = {
      appver: appVersion,
      ostype: deviceType,
      appname: "HXCF_APP",
      osver: osver
    }
    dispatch(getVersionInfo(params, (data) => {
      console.log(data)
      this.androidUrl=data.data.url;
      console.log(this.androidUrl);
    }, 
    (err) => {
      console.log(err, "**********************")
    }));
    
  }
  dateData(property, bol) {
    return function(a, b) {
      var value1 = a[property];
      var value2 = b[property];
      if (bol) {
        // 升序
        return Date.parse(value1) - Date.parse(value2);
      } else {
        // 降序
        return Date.parse(value2) - Date.parse(value1)
      }
    }
  }
    datacl(data){
    this.setState({
      publicFundPerformanceflag:false
    })
    let Data=[]
    if(data.publicFundPerformanceResponseList !== null || data.publicFundPerformanceResponseList.length>0){
      let mergedArray = data.publicFundPerformanceResponseList.concat(data.publicFundBenchmarkPerformanceResponseList, data.indexPerformanceResponseList);
      let mergedObject = {};
      mergedArray.forEach(item => {
        const date = item.trendDate;
      if (!mergedObject[date]) {
      mergedObject[date] = {
      value: null,
      allIncome: null,
      Lineval: null,
      maxDrawDown: null,
      deadLine: item.trendDate
      };
      }
      mergedObject[date].value = null;
      mergedObject[date].allIncome =null ;
      mergedObject[date].Lineval = null;
      });
      let resultArray =(Object.values(mergedObject)).sort(this.dateData("deadLine", true)) ;
      let publicFundPerformanceResponseList=data.publicFundPerformanceResponseList
      let publicFundBenchmarkPerformanceResponseList=data.publicFundBenchmarkPerformanceResponseList
      let indexPerformanceResponseList=data.indexPerformanceResponseList

      let arr1=new Map()
      for (let i = publicFundPerformanceResponseList.length - 1; i >= 0; i--) {
        arr1.set(publicFundPerformanceResponseList[i].trendDate,publicFundPerformanceResponseList[i])
     }
        let arr2=new Map()
        for (let i = publicFundBenchmarkPerformanceResponseList.length - 1; i >= 0; i--) {
          arr2.set(publicFundBenchmarkPerformanceResponseList[i].trendDate,publicFundBenchmarkPerformanceResponseList[i])
       }
       let arr3=new Map()
       for (let i = indexPerformanceResponseList.length - 1; i >= 0; i--) {
        arr3.set(indexPerformanceResponseList[i].trendDate,indexPerformanceResponseList[i])
      }
      let hebing=[]
      let hebing1=[]
      let hebing2=[]
      resultArray.forEach((value, index)=>{
        let data=value.deadLine
        if(arr1.has(data)){
        let object = arr1.get(data);
        let object1 = value;
          object1.value = object.sumTrend;
          object1.valueTrend = object.trend;
          hebing.push(object1)
        }else{
        let object = value;
          object.value = null;
          object.valueTrend =null;
          hebing.push(object)
        }
      });
      hebing.forEach((value, index)=>{
        let data=value.deadLine
        if(arr2.has(data)){
          let object = arr2.get(data);
          let object1 = value;
          object1.allIncome = object.sumTrend;
          object1.allIncomeTrend = object.trend;
          hebing1.push(object1)
        }else{
        let object = value;
          object.allIncome = null;
          object.allIncomeTrend =null;
          hebing1.push(object)
        }
      });
      hebing1.forEach((value, index)=>{
        let data=value.deadLine
        if(arr3.has(data)){
          let object = arr3.get(data);
          let object1 = value;
          object1.Lineval = object.sumTrend;
          object1.LinevalTrend = object.trend;
          hebing2.push(object1)
        }else{
        let object = value;
          object.Lineval = null;
          object.LinevalTrend =null;
          hebing2.push(object)
        }
      });
    if(this.state.Notenoughforoneyear !== -1){
      let allStartDate = data.maxDrawDownStart ? getDateS(data.maxDrawDownStart):null;   
      let allEndDate =  data.maxDrawDownEnd ?  getDateS(data.maxDrawDownEnd):null
        if(allStartDate&&allEndDate){
          for (let i =0;i< hebing2.length; i++){
            let deadLine= getDateS(hebing2[i].deadLine)
            if( (deadLine.getTime() < allStartDate.getTime() ) || (deadLine.getTime() > allEndDate.getTime()) ){
              Data.push({ value:hebing2[i].value,valueTrend:hebing2[i].valueTrend,allIncome: hebing2[i].allIncome,allIncomeTrend:hebing2[i].allIncomeTrend,Lineval:hebing2[i].Lineval,LinevalTrend:hebing2[i].LinevalTrend,maxDrawDown:null,deadLine: hebing2[i].deadLine})
            }else{
              Data.push({ value:hebing2[i].value,valueTrend:hebing2[i].valueTrend,allIncome: hebing2[i].allIncome,allIncomeTrend:hebing2[i].allIncomeTrend,Lineval:hebing2[i].Lineval,LinevalTrend:hebing2[i].LinevalTrend,maxDrawDown:hebing2[i].value,deadLine: hebing2[i].deadLine})
            }
          }
        }else{
          for (let i =0;i< hebing2.length; i++){
              Data.push({ value:hebing2[i].value,valueTrend:hebing2[i].valueTrend,allIncome: hebing2[i].allIncome,allIncomeTrend:hebing2[i].allIncomeTrend,Lineval:hebing2[i].Lineval,LinevalTrend:hebing2[i].LinevalTrend,maxDrawDown:null,deadLine: hebing2[i].deadLine})
          }
        }
        if(data.publicFundBenchmarkPerformanceResponseList.length == 0){
          this.setState({
            publicFundPerformanceflag:true
          })
          }
    }else{
      Data=hebing2
      if(data.publicFundBenchmarkPerformanceResponseList.length == 0){
        this.setState({
          publicFundPerformanceflag:true
        })
        }
    }
  }
  // console.log(Data)
    return Data
  }
  scrollFun=(_this,e)=>{
    let hei = e.target.scrollTop
    if(hei>100){
      _this.setState({tebflag:true})
    }else{
      _this.setState({tebflag:false})
    }
    if(hei>=0 && hei < _this.arr[1])_this.setState({tabtext:_this.state.tabtextList[0]})
    if(hei>=_this.arr[1] && hei < (_this.arr[2]-1))_this.setState({tabtext:_this.state.tabtextList[1]})
    if(hei>=(_this.arr[2]-1) && hei < (_this.arr[3]-1))_this.setState({tabtext:_this.state.tabtextList[2]})
    if(hei>=(_this.arr[3]-1))_this.setState({tabtext:_this.state.tabtextList[3]})
  }
  handleCallback(data){
    let tabtextarr = []
    if(data.PublicDetilInfo[0]&& data.PublicDetilInfo[0].fundType==='货币型'){
      tabtextarr = ['行情','业绩','规则','档案']
    }else{
      tabtextarr = ['净值','业绩','规则','档案']
    }
    this.setState({
      dataSource:data,
      fundcode:data.PublicDetilInfo[0].fundcode,
      is_optional:data.is_optional,
      isTaxDeferredProduct:data.isTaxDeferredProduct, //获取养老个税产品标识
      icatorFlag:(data.fundAnalysisIndicatorFlag === true && data.PublicDetilInfo[0].fundtype != "货币型") ? true:false,
      dataInfo:data.PublicDetilInfo[0],//基本信息
      Netperformance:data.PublicDetilProfit[0],//净值业绩
      buyTradeRule :data.buyTradeRule,  //交易规则
      PublicDetilBaseInfo:data.PublicDetilBaseInfo[0],//基金档案
      PublicDetilManager:data.PublicDetilManager,  //基金经理
      latestDividend:data.latestDividend,  //分红记录
      latestPublicFundAnnouncement:data.latestPublicFundAnnouncement,  //基金公告
      acRelationFundCode:data.acRelationFundCode,  //a c类产品
      relationFundName:data.relationFundName,  //a c类产品名
      fundCode:data.PublicDetilInfo[0].fundcode,
      tabtextList:tabtextarr,
      discountRateHundredPercent:data.discountRateHundredPercent,
      maxBuyRateHundredPercent:data.maxBuyRateHundredPercent,
      Notenoughforoneyear:dateDeath(data.PublicDetilBaseInfo[0].fundstartdate).indexOf("年"),//基金成立满不满足一年
      chengli:dateDeath(data.PublicDetilBaseInfo[0].fundstartdate),//基金成立多少天
      invest:data.publicDetailAssetVoList
    },()=>{
      this.scrollView = document.getElementById('scrollView')
      this.scrollView.addEventListener('scroll',(e)=>this.scrollFun(this,e),false)
      let echartsRef = document.getElementById('echartsbox').offsetTop
      let ruleRef = document.getElementById('rule').offsetTop
      let filesRef = document.getElementById('files').offsetTop
      this.arr = [0,echartsRef-45,ruleRef-45,filesRef-45]
    })
    let {dispatch} = this.props
    let { fundcode } = this.state
    //打点数据
    this.echinterface(data)

    if(data.PublicDetilInfo[0].fundtype !== '货币型'){
       //净值
       let getHdata = {type:1,fundcode:fundcode}
       dispatch(getPublicHistoryProfileRate(getHdata,(data) => { 
        // console.log(data,"净值")
        let AccumulatedNet=(data.HistoryRate).reverse()
        this.setState({
          AccumulatedNet:AccumulatedNet.slice(0,4),
        })
       },this));
    let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"m1"}
    dispatch(Newpublicinterface(params, (data) => { 
      console.log(data, '折线图data')
        // buyDateList[yy--mm-mm,] 买入打点 
        // dividendDateList 分红日期打点
        // redeemDateList 卖出打点
        // publicFundBenchmarkPerformanceResponseList 业绩基准
        // publicFundPerformanceResponseList 本基金
        let IndexData=this.datacl(data)
      this.setState({
        publicFundPerformanceResponseList:data.publicFundPerformanceResponseList,
        publicFundBenchmarkPerformanceResponseList:data.publicFundBenchmarkPerformanceResponseList,
        indexPerformanceResponseList:data.indexPerformanceResponseList,
        chartsDataArr: { ...this.state.chartsDataArr, oneMonth: IndexData,oneMonthpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
        maxDrawDownArr:{ ...this.state.maxDrawDownArr,OneMonthmaxDrawDownValue:data.maxDrawDownValue}
      }) 
      this.changeEchartsData(this.state.tabVal, IndexData, this.state.selectTab,data.maxDrawDownValue)
     }));

      this.setState({
        tabVal:"七日年化",
        initialPage:0
      })
      this.tabValFun('业绩走势',0)
    }else{
      this.tabValFun('七日年化',0)
    }
    let datasum=this.investmentallocation(data)
    let sum= 0
    datasum.map((item,index)=>{
      sum = Number(Number(item.value) + (sum - 0)).toFixed(2);
    })
    
    this.setState({
      sum:sum,
    })
  }
  //打点数据接口
  echinterface(data){
    let {dispatch} = this.props
    let {fundcode} = this.state
    let Dotparams = { fundCode: fundcode};
    data.PublicDetilInfo[0].fundtype == '货币型'? null:dispatch(Newpublicinterfacedadian(Dotparams, (data) => { this.setState({dividDateList:data.dividendDateList,}),console.log(data, '未登录打点数据') }), this);
  }

  
  tabValFun = (selectTab, num) => {
    let val=this.state.selectTab//时间区间
    this.setState({ 
      tabVal: selectTab, 
      initialPage: num })
    const theFun = (_selectTab,val) => {
      let fundcode=this.state.fundCode
      if (_selectTab == '业绩走势') {
        if (val == '近1月') {
            this.setState({
              loadingFlag: true,
              OneMonthBasicffsa:true,
              type:"m1"
             });
             let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"m1"}
            this.props.dispatch(Newpublicinterface(params, (data) => { 
              let IndexData=this.datacl(data)
              this.changeEchartsData(_selectTab, IndexData, this.state.selectTab,data.maxDrawDownValue),
              this.setState({
              chartsDataArr: { ...this.state.chartsDataArr, oneMonth: IndexData,oneMonthpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
              loadingFlag: false, 
              maxDrawDownArr:{ ...this.state.maxDrawDownArr,OneMonthmaxDrawDownValue:data.maxDrawDownValue}
              }) 
            }));
        } else if (val == '近3月') {
            this.setState({
              loadingFlag: true,
              ThreeMonthBasicffsa:true,
              type:"m3"
             });
             let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"m3"}
            this.props.dispatch(Newpublicinterface(params, (data) => { 
              let IndexData=this.datacl(data)
              this.changeEchartsData(_selectTab, IndexData, this.state.selectTab,data.maxDrawDownValue),
              this.setState({
                 chartsDataArr: { ...this.state.chartsDataArr, threeMonth: IndexData,threeMonthpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
                loadingFlag: false, 
                maxDrawDownArr:{ ...this.state.maxDrawDownArr,ThreeMonthmaxDrawDownValue:data.maxDrawDownValue}
              }) 
            }));

        } else if (val == '近6月') {
            this.setState({
              loadingFlag: true,
              SixMonthBasicffsa:true,
              type:"m6"
             });
             let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"m6"}
            this.props.dispatch(Newpublicinterface(params, (data) => { 
              let IndexData=this.datacl(data)
              this.changeEchartsData(_selectTab, IndexData, this.state.selectTab,data.maxDrawDownValue),
              this.setState({
                 chartsDataArr: { ...this.state.chartsDataArr, sixMonth: IndexData,sixMonthpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
                loadingFlag: false, 
                maxDrawDownArr:{ ...this.state.maxDrawDownArr,SixMonthmaxDrawDownValue:data.maxDrawDownValue}

              }) 
            }));
        } else if (val == '近1年') {
            this.setState({
              loadingFlag: true,
              OneYearBasicffsa:true,
              type:"y1"
             });
             let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"y1"}
            this.props.dispatch(Newpublicinterface(params, (data) => { 
              let IndexData=this.datacl(data)
              this.changeEchartsData(_selectTab, IndexData, this.state.selectTab,data.maxDrawDownValue),
              this.setState({
                 chartsDataArr: { ...this.state.chartsDataArr, oneYear: IndexData,oneYearpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
                loadingFlag: false, 
                maxDrawDownArr:{ ...this.state.maxDrawDownArr,OneYearmaxDrawDownValue:data.maxDrawDownValue}
              }) 
            }));
        }else if (val == '今年以来') {
            this.setState({
              loadingFlag: true,
              ThisyearBasicffsa:true,
              type:"thisyear"
             });
             let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"thisyear"}
            this.props.dispatch(Newpublicinterface(params, (data) => { 
              let IndexData=this.datacl(data)
              this.changeEchartsData(_selectTab, IndexData, this.state.selectTab,data.maxDrawDownValue),
              this.setState({
                 chartsDataArr: { ...this.state.chartsDataArr, thisyear: IndexData,thisyearpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
                loadingFlag: false, 
                maxDrawDownArr:{ ...this.state.maxDrawDownArr,ThisyearmaxDrawDownValue:data.maxDrawDownValue}
              }) 
            }));
        }else if (val == '近3年') {
            this.setState({
              loadingFlag: true,
              ThreeYearBasicffsa:true,
              type:"y3"
             });
             let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"y3"}
            this.props.dispatch(Newpublicinterface(params, (data) => { 
              let IndexData=this.datacl(data)
              this.changeEchartsData(_selectTab, IndexData, this.state.selectTab,data.maxDrawDownValue),
              this.setState({
                 chartsDataArr: { ...this.state.chartsDataArr, ThreeYear: IndexData,ThreeYearpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
                loadingFlag: false, 
                maxDrawDownArr:{ ...this.state.maxDrawDownArr,ThreeYearmaxDrawDownValue:data.maxDrawDownValue}
              }) 
            }));
        }else if (val == '近5年') {
            this.setState({
              loadingFlag: true,
              FiveYearBasicffsa:true,
              type:"y5"
             });
             let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"y5"}
            this.props.dispatch(Newpublicinterface(params, (data) => { 
              let IndexData=this.datacl(data)
              this.changeEchartsData(_selectTab, IndexData, this.state.selectTab,data.maxDrawDownValue),
              this.setState({
                 chartsDataArr: { ...this.state.chartsDataArr, fiveYear: IndexData,fiveYearpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
                maxDrawDownArr:{ ...this.state.maxDrawDownArr,FiveYearmaxDrawDownValue:data.maxDrawDownValue}
              }) 
            }));
        } else if (val == '成立以来') {
            this.setState({
              loadingFlag: true,
              AllDataBasicffsa:true,
              type:"sincefound"
             });
             let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"sincefound"}
            this.props.dispatch(Newpublicinterface(params, (data) => { 
              let IndexData=this.datacl(data)
              this.changeEchartsData(_selectTab, IndexData, this.state.selectTab,data.maxDrawDownValue),
              this.setState({
                 chartsDataArr: { ...this.state.chartsDataArr, allData: IndexData,allDatapublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
                maxDrawDownArr:{ ...this.state.maxDrawDownArr,AllDatamaxDrawDownValue:data.maxDrawDownValue}
              }) 
            }));
        }
      }else {
        this.setState({ tabloadingFlag: true,loadingFlag:true })
        if (this.state.echartsData !== null) {
          this.changeEchartsData(_selectTab, this.state.echartsData, val);
          this.setState({ tabloadingFlag: false })
        } else {
          let getHdata = {type:1,fundcode:this.state.fundCode}
          this.props.dispatch(getPublicHistoryProfileRate(getHdata,(data)=>{
            let AccumulatedNet=(data.HistoryRate).reverse()
            this.setState({
              AccumulatedNet:AccumulatedNet.slice(0,4),
            })
            this.changeEchartsData(this.state.tabVal, data, this.state.selectTab)
          },this));
        }
      }
    }
    theFun(selectTab,val);
  }
      //折线图数值
      changeEchartsData = (_val, data, val,maxDrawDownValue) => {
        // console.log(_val, data, val,maxDrawDownValue)
        let _oneMonthDate = [];//一个月
        let _oneMonthNav = [];
        let _threeMonthDate = [];//三个月
        let _threeMonthNav = [];
        let _sixMonthDate = [];//六个月
        let _sixMonthNav = [];
        
        let _oneYearDate = [];//一年
        let _oneYearNav = [];
  
        let _thisyearDate = [];//今年以来
        let _thisyearNav = [];
  
        let _ThreeYearDate = [];//三年
        let _ThreeYearNav = [];
  
        let _fiveYearDate = [];//五年
        let _fiveYearNav = [];
  
        let _totalDate = [];//成立以来
        let _totalNav = [];
        let _oneArr = []
        let _threeArr = [];
        let _sixArr = [];
        let _yearArr = [];
        let _ThreeArr=[];
        let _fiveArr=[]
        let _thisyearArr=[]
        let _totalArr = [];
        let _profitNav = [];
        let _profitData = [];
        let oneMonth = getOneMonthBefor();
        let threeMonth = get3MonthBefor();
        let sixMonth = getSixMonthBefor();
        let oneYear = get1yearBefor();
        let thisyearYear = Fromthisyear();
        let ThreeYear = get3yearBefor();
        let fiveYear = get5yearBefor();
  
        let datas = [];
          let Datacontnet = data.HistoryRate;
          if (_val === '业绩走势') {
            _profitNav = []
            _profitData = []
            if(this.state.Notenoughforoneyear == 1){
              for (let i = data.length - 1; i >= 0; i--) {
                _profitNav.push({ value:Util.Keepwodecimalplaces(data[i].value), allIncome: data[i].allIncome,Lineval:data[i].Lineval,maxDrawDown:data[i].maxDrawDown,deadLine: data[i].deadLine})
                _profitData.push(data[i].deadLine);
              }
            }else{
              for (let i = data.length - 1; i >= 0; i--) {
                _profitNav.push({ value:Util.Keepwodecimalplaces(data[i].value), allIncome: data[i].allIncome,Lineval:data[i].Lineval,maxDrawDown:null,deadLine: data[i].deadLine})
                _profitData.push(data[i].deadLine);
              }
            }
            _profitNav = _profitNav.reverse();
            _profitData = _profitData.reverse();
            let _dotnav = []
            _profitNav.map((item,index)=>{
              _dotnav.push(item.value)
            })
              this.setState({
                profitNav: _profitNav,
                profitData: _profitData,
              });
            datas = {
              _profitNav: _profitNav,
              _profitData: _profitData,
              _dotnav:_dotnav,
              _selectTab: val,
              _maxDrawDownValue:maxDrawDownValue
            };
            setTimeout(() => {
              this.echartsbox.showOption(datas);
            }, 0);
            setTimeout(() => {
              this.setState({
                loadingFlag: false, 
              });
            }, 100);

          } else {
              for (let i = Datacontnet.length - 1; i >= 0; i--) {
                _totalDate.push(Datacontnet[i].publish_date);
                if (_val == "单位净值") {
                  _totalNav.push(Datacontnet[i].value_134);
                } else if (_val == "累计净值") {
                  _totalNav.push(Datacontnet[i].value_134_2);
                } else if (_val == "万份收益") {
                  _totalNav.push(Datacontnet[i].value_2_1);
                } else if (_val == "七日年化") {
                  _totalNav.push(Datacontnet[i].value_2_2);
                }
  
                if(compareTime(fiveYear, Datacontnet[i].publish_date)){
                  _fiveYearDate.push(Datacontnet[i].publish_date);
                  if (_val == "单位净值") {
                    _fiveYearNav.push(Datacontnet[i].value_134);
                  } else if (_val == "累计净值") {
                    _fiveYearNav.push(Datacontnet[i].value_134_2);
                  } else if (_val == "万份收益") {
                    _fiveYearNav.push(Datacontnet[i].value_2_1);
                  } else if (_val == "七日年化") {
                    _fiveYearNav.push(Datacontnet[i].value_2_2);
                  }
                if(compareTime(ThreeYear, Datacontnet[i].publish_date)){
                  _ThreeYearDate.push(Datacontnet[i].publish_date);
                  if (_val == "单位净值") {
                    _ThreeYearNav.push(Datacontnet[i].value_134);
                  } else if (_val == "累计净值") {
                    _ThreeYearNav.push(Datacontnet[i].value_134_2);
                  } else if (_val == "万份收益") {
                    _ThreeYearNav.push(Datacontnet[i].value_2_1);
                  } else if (_val == "七日年化") {
                    _ThreeYearNav.push(Datacontnet[i].value_2_2);
                  }
                    if (compareTime(oneYear, Datacontnet[i].publish_date)) {
                      _oneYearDate.push(Datacontnet[i].publish_date);
                      if (_val == "单位净值") {
                        _oneYearNav.push(Datacontnet[i].value_134);
                      } else if (_val == "累计净值") {
                        _oneYearNav.push(Datacontnet[i].value_134_2);
                      } else if (_val == "万份收益") {
                        _oneYearNav.push(Datacontnet[i].value_2_1);
                      } else if (_val == "七日年化") {
                        _oneYearNav.push(Datacontnet[i].value_2_2);
                      }
                      if(compareTime(thisyearYear, Datacontnet[i].publish_date)){
                        _thisyearDate.push(Datacontnet[i].publish_date);
                        if (_val == "单位净值") {
                          _thisyearNav.push(Datacontnet[i].value_134);
                        } else if (_val == "累计净值") {
                           _thisyearNav.push(Datacontnet[i].value_134_2);
                        } else if (_val == "万份收益") {
                           _thisyearNav.push(Datacontnet[i].value_2_1);
                        } else if (_val == "七日年化") {
                           _thisyearNav.push(Datacontnet[i].value_2_2);
                        }
                      if (compareTime(sixMonth, Datacontnet[i].publish_date)) {
                        _sixMonthDate.push(Datacontnet[i].publish_date);
                        if (_val == "单位净值") {
                          _sixMonthNav.push(Datacontnet[i].value_134);
                        } else if (_val == "累计净值") {
                          _sixMonthNav.push(Datacontnet[i].value_134_2);
                        } else if (_val == "万份收益") {
                          _sixMonthNav.push(Datacontnet[i].value_2_1);
                        } else if (_val == "七日年化") {
                          _sixMonthNav.push(Datacontnet[i].value_2_2);
                        }
                        if (compareTime(threeMonth, Datacontnet[i].publish_date)) {
                          _threeMonthDate.push(Datacontnet[i].publish_date);
                          if (_val == "单位净值") {
                            _threeMonthNav.push(Datacontnet[i].value_134);
                          } else if (_val == "累计净值") {
                            _threeMonthNav.push(Datacontnet[i].value_134_2);
                          } else if (_val == "万份收益") {
                            _threeMonthNav.push(Datacontnet[i].value_2_1);
                          } else if (_val == "七日年化") {
                            _threeMonthNav.push(Datacontnet[i].value_2_2);
                          }
                          if (compareTime(oneMonth, Datacontnet[i].publish_date)) {
                            _oneMonthDate.push(Datacontnet[i].publish_date);
                            if (_val == "单位净值") {
                              _oneMonthNav.push(Datacontnet[i].value_134);
                            } else if (_val == "累计净值") {
                              _oneMonthNav.push(Datacontnet[i].value_134_2);
                            } else if (_val == "万份收益") {
                              _oneMonthNav.push(Datacontnet[i].value_2_1);
                            } else if (_val == "七日年化") {
                              _oneMonthNav.push(Datacontnet[i].value_2_2);
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
    
            for (let i = 0; i < _oneMonthDate.length; i++) {
              if (_oneMonthDate[i]) {
                _oneArr.push(_oneMonthDate[i]);
              }
            }
            for (let i = 0; i < _threeMonthDate.length; i++) {
              if (_threeMonthDate[i]) {
                _threeArr.push(_threeMonthDate[i]);
              }
            }
            for (let i = 0; i < _sixMonthDate.length; i++) {
              if (_sixMonthDate[i]) {
                _sixArr.push(_sixMonthDate[i]);
              }
            }
            for (let i = 0; i < _oneYearDate.length; i++) {
              if (_oneYearDate[i]) {
                _yearArr.push(_oneYearDate[i]);
              }
            }
            //今年以来
            for (let i = 0; i < _thisyearDate.length; i++) {
              if (_thisyearDate[i]) {
                _thisyearArr.push(_thisyearDate[i]);
              }
            }
            for (let i = 0; i < _ThreeYearDate.length; i++) {
              if (_ThreeYearDate[i]) {
                _ThreeArr.push(_ThreeYearDate[i]);
              }
            }
            for (let i = 0; i < _fiveYearDate.length; i++) {
              if (_fiveYearDate[i]) {
                _fiveArr.push(_fiveYearDate[i]);
              }
            }
            for (let i = 0; i < _totalDate.length; i++) {
              if (_totalDate[i]) {
                _totalArr.push(_totalDate[i]);
              }
            }
            this.setState({
              oneMonthDate: _oneArr,
              oneMonthNav: _oneMonthNav,
              
              threeMonthDate: _threeArr,
              threeMonthNav: _threeMonthNav,
              
              sixMonthDate: _sixArr,
              sixMonthNav: _sixMonthNav,
  
              oneYearDate: _yearArr,
              oneYearNav: _oneYearNav,
  
              thisyearDate:_thisyearArr,
              thisyearNav: _thisyearNav,
  
              ThreeYearDate:_ThreeArr,//三年
              ThreeYearNav:_ThreeYearNav,
  
              fiveYearDate:_fiveArr,//五年
              fiveYearNav:_fiveYearNav,
  
              totalDate: _totalArr,
              totalNav: _totalNav,
  
              echartsData: data,
            });
            datas = {
              oneMonthDate: _oneArr,
              oneMonthNav: _oneMonthNav,
  
              threeMonthDate: _threeArr,
              threeMonthNav: _threeMonthNav,
  
              sixMonthDate: _sixArr,
              sixMonthNav: _sixMonthNav,
  
              oneYearDate: _yearArr,
              oneYearNav: _oneYearNav,
  
              thisyearDate:_thisyearArr,
              thisyearNav: _thisyearNav,
  
              ThreeYearDate:_ThreeArr,//三年
              ThreeYearNav:_ThreeYearNav,
  
              fiveYearDate:_fiveArr,//五年
              fiveYearNav:_fiveYearNav,
  
              totalDate: _totalArr,
              totalNav: _totalNav,
            }
            setTimeout(() => {
              this.echartsbox.showOptionNav(datas, val);
            }, 0);
            setTimeout(() => {
              this.setState({
                loadingFlag: false, 
              });
            }, 50);
          }
      }

  //折线图点击事件
  selectTabFun = (val) => {
    this.setState({
       selectTab: val,initialPage:this.state.initialPage,selectOther:false,
      })
      let fundcode=this.state.fundCode
    if (this.state.tabVal == '业绩走势') {
      if (val == '近1月') {
        if(this.state.chartsDataArr.oneMonth.length>0 && this.state.OneMonthBasicffsa){
          this.setState({
            type:"m1",
            publicFundPerformanceflag:this.state.chartsDataArr.oneMonthpublicFundflag
           });
          this.changeEchartsData(this.state.tabVal, this.state.chartsDataArr.oneMonth, this.state.selectTab,this.state.maxDrawDownArr.OneMonthmaxDrawDownValue)
        }else{
          this.setState({
            loadingFlag: true,
            OneMonthBasicffsa:true,
            type:"m1"
           });
           let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"m1"}
          this.props.dispatch(Newpublicinterface(params, (data) => { 
            let IndexData=this.datacl(data)
            this.changeEchartsData(this.state.tabVal, IndexData, this.state.selectTab,data.maxDrawDownValue),
            this.setState({
              chartsDataArr: { ...this.state.chartsDataArr, oneMonth: IndexData,oneMonthpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
              maxDrawDownArr:{ ...this.state.maxDrawDownArr, OneMonthmaxDrawDownValue:data.maxDrawDownValue},
              loadingFlag: false, 
            }) 
          }));
        }
      } else if (val == '近3月') {
        if(this.state.chartsDataArr.threeMonth.length>0 && this.state.ThreeMonthBasicffsa){
          this.setState({
            type:"m3",
            publicFundPerformanceflag:this.state.chartsDataArr.threeMonthpublicFundflag
           });
          this.changeEchartsData(this.state.tabVal, this.state.chartsDataArr.threeMonth, this.state.selectTab,this.state.maxDrawDownArr.ThreeMonthmaxDrawDownValue)
        }else{
          this.setState({
            loadingFlag: true,
            ThreeMonthBasicffsa:true,
            type:"m3"
           });
           let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"m3"}
          this.props.dispatch(Newpublicinterface(params, (data) => { 
            let IndexData=this.datacl(data)
            this.changeEchartsData(this.state.tabVal, IndexData, this.state.selectTab,data.maxDrawDownValue),
            this.setState({
              chartsDataArr: { ...this.state.chartsDataArr, threeMonth: IndexData ,threeMonthpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
              maxDrawDownArr:{ ...this.state.maxDrawDownArr, ThreeMonthmaxDrawDownValue:data.maxDrawDownValue},
              loadingFlag: false, 
            }) 
          }));
        }
      } else if (val == '近6月') {
        if(this.state.chartsDataArr.sixMonth.length>0 && this.state.SixMonthBasicffsa){
          this.setState({
            type:"m6",
            publicFundPerformanceflag:this.state.chartsDataArr.sixMonthpublicFundflag
           });
          this.changeEchartsData(this.state.tabVal, this.state.chartsDataArr.sixMonth, this.state.selectTab,this.state.maxDrawDownArr.SixMonthmaxDrawDownValue)
        }else{
          this.setState({
            loadingFlag: true,
            SixMonthBasicffsa:true,
            type:"m6"
           });
           let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"m6"}
          this.props.dispatch(Newpublicinterface(params, (data) => { 
            let IndexData=this.datacl(data)
            this.changeEchartsData(this.state.tabVal, IndexData, this.state.selectTab,data.maxDrawDownValue),
            this.setState({
              chartsDataArr: { ...this.state.chartsDataArr, sixMonth: IndexData ,sixMonthpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
              maxDrawDownArr:{ ...this.state.maxDrawDownArr, SixMonthmaxDrawDownValue:data.maxDrawDownValue},
              loadingFlag: false, 
            }) 
          }));
        }
      } else if (val == '近1年') {
        if(this.state.chartsDataArr.oneYear.length>0 && this.state.OneYearBasicffsa){
          this.setState({
            type:"y1",
            publicFundPerformanceflag:this.state.chartsDataArr.oneYearpublicFundflag
           });
          this.changeEchartsData(this.state.tabVal, this.state.chartsDataArr.oneYear, this.state.selectTab,this.state.maxDrawDownArr.OneYearmaxDrawDownValue)
        }else{
          this.setState({
            loadingFlag: true,
            OneYearBasicffsa:true,
            type:"y1"
           });
           let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"y1"}
          this.props.dispatch(Newpublicinterface(params, (data) => { 
            let IndexData=this.datacl(data)
            this.changeEchartsData(this.state.tabVal, IndexData, this.state.selectTab,data.maxDrawDownValue),
            this.setState({
               chartsDataArr: { ...this.state.chartsDataArr, oneYear: IndexData,oneYearpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
              maxDrawDownArr:{ ...this.state.maxDrawDownArr, OneYearmaxDrawDownValue:data.maxDrawDownValue},
               loadingFlag: false, 
            }) 
          }));
        }
      }else if (val == '今年以来') {
        if(this.state.chartsDataArr.thisyear.length>0 && this.state.ThisyearBasicffsa){
          this.setState({
            type:"thisyear",
            publicFundPerformanceflag:this.state.chartsDataArr.thisyearpublicFundflag
           });
          this.changeEchartsData(this.state.tabVal, this.state.chartsDataArr.thisyear, this.state.selectTab,this.state.maxDrawDownArr.ThisyearmaxDrawDownValue)
        }else{
          this.setState({
            loadingFlag: true,
            ThisyearBasicffsa:true,
            type:"thisyear"
           });
           let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"thisyear"}
          this.props.dispatch(Newpublicinterface(params, (data) => { 
            let IndexData=this.datacl(data)
            this.changeEchartsData(this.state.tabVal, IndexData, this.state.selectTab,data.maxDrawDownValue),
            this.setState({
               chartsDataArr: { ...this.state.chartsDataArr, thisyear: IndexData,thisyearpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
              maxDrawDownArr:{ ...this.state.maxDrawDownArr, ThisyearmaxDrawDownValue:data.maxDrawDownValue},
            loadingFlag: false, 
            }) 
          }));
        }
      }else if (val == '近3年') {
        if(this.state.chartsDataArr.ThreeYear.length>0 && this.state.ThreeYearBasicffsa){
          this.setState({
            type:"y3",
            publicFundPerformanceflag:this.state.chartsDataArr.ThreeYearpublicFundflag
           });
          this.changeEchartsData(this.state.tabVal, this.state.chartsDataArr.ThreeYear, this.state.selectTab,this.state.maxDrawDownArr.ThreeYearmaxDrawDownValue)
        }else{
          this.setState({
            loadingFlag: true,
            ThreeYearBasicffsa:true,
            type:"y3"
           });
           let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"y3"}
          this.props.dispatch(Newpublicinterface(params, (data) => { 
            let IndexData=this.datacl(data)
            this.changeEchartsData(this.state.tabVal, IndexData, this.state.selectTab,data.maxDrawDownValue),
            this.setState({
               chartsDataArr: { ...this.state.chartsDataArr, ThreeYear: IndexData ,ThreeYearpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
              maxDrawDownArr:{ ...this.state.maxDrawDownArr, ThreeYearmaxDrawDownValue:data.maxDrawDownValue},
            loadingFlag: false, 
            }) 
          }));
        }
      }else if (val == '近5年') {
        if(this.state.chartsDataArr.fiveYear.length>0 && this.state.FiveYearBasicffsa){
          this.setState({
            type:"y5",
            publicFundPerformanceflag:this.state.chartsDataArr.fiveYearpublicFundflag
           });
          this.changeEchartsData(this.state.tabVal, this.state.chartsDataArr.fiveYear, this.state.selectTab,this.state.maxDrawDownArr.FiveYearmaxDrawDownValue)
        }else{
          this.setState({
            loadingFlag: true,
            FiveYearBasicffsa:true,
            type:"y5"
           });
           let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"y5"}
          this.props.dispatch(Newpublicinterface(params, (data) => { 
            let IndexData=this.datacl(data)
            this.changeEchartsData(this.state.tabVal, IndexData, this.state.selectTab,data.maxDrawDownValue),
            this.setState({
               chartsDataArr: { ...this.state.chartsDataArr, fiveYear: IndexData ,fiveYearpublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
              maxDrawDownArr:{ ...this.state.maxDrawDownArr, FiveYearmaxDrawDownValue:data.maxDrawDownValue},
            }) 
          }));
        }
      } else if (val == '成立以来') {
        if(this.state.chartsDataArr.allData.length>0 && this.state.AllDataBasicffsa){
          this.setState({
            type:"sincefound",
            publicFundPerformanceflag:this.state.chartsDataArr.allDatapublicFundflag
           });
          this.changeEchartsData(this.state.tabVal, this.state.chartsDataArr.allData, this.state.selectTab,this.state.maxDrawDownArr.AllDatamaxDrawDownValue)
        }else{
          this.setState({
            loadingFlag: true,
            AllDataBasicffsa:true,
            type:"sincefound"
           });
           let params = { fundCode:fundcode,symbolCode:this.state.symbolcode,type:"sincefound"}
          this.props.dispatch(Newpublicinterface(params, (data) => { 
            let IndexData=this.datacl(data)
            this.changeEchartsData(this.state.tabVal, IndexData, this.state.selectTab,data.maxDrawDownValue),
            this.setState({
               chartsDataArr: { ...this.state.chartsDataArr, allData: IndexData,allDatapublicFundflag:data.publicFundBenchmarkPerformanceResponseList.length>0?false:true } ,
              maxDrawDownArr:{ ...this.state.maxDrawDownArr, AllDatamaxDrawDownValue:data.maxDrawDownValue},
            }) 
          }));
        }
        }
    } else {
      if (this.state.echartsData !== null) {
        let datas = {
          oneMonthDate: this.state.oneMonthDate,
          oneMonthNav: this.state.oneMonthNav,
          threeMonthDate: this.state.threeMonthDate,
          threeMonthNav: this.state.threeMonthNav,
          sixMonthDate: this.state.sixMonthDate,
          sixMonthNav: this.state.sixMonthNav,
          oneYearDate: this.state.oneYearDate,
          oneYearNav: this.state.oneYearNav,
          thisyearDate:this.state.thisyearDate,
          thisyearNav: this.state.thisyearNav,
          ThreeYearDate:this.state.ThreeYearDate,//三年
          ThreeYearNav:this.state.ThreeYearNav,
          fiveYearDate:this.state.fiveYearDate,//五年
          fiveYearNav:this.state.fiveYearNav,
          totalDate: this.state.totalDate,
          totalNav: this.state.totalNav
        }
        if (val == '近1月') {
          this.echartsbox.showOptionNav(datas, val)
        } else if (val == '近3月') {
          this.echartsbox.showOptionNav(datas, val)
        } else if (val == '近6月') {
          this.echartsbox.showOptionNav(datas, val)
        } else if (val == '近1年') {
          this.echartsbox.showOptionNav(datas, val)
        } else if (val == '今年以来') {
          this.echartsbox.showOptionNav(datas, val)
        } else if (val == '近3年') {
          this.echartsbox.showOptionNav(datas, val)
        } else if (val == '近5年') {
          this.echartsbox.showOptionNav(datas, val)
        } else if (val == '成立以来') {
          this.echartsbox.showOptionNav(datas, val)
        }
      }
    }
  }
  
  onRef = (ref) => {
    this.echartsbox = ref
  }
  handleLocation(id){
    this.scrollView.scrollTo({top:this.arr[id],behavior:'smooth'})
  }
  
  ResetDetail(){
    let { dispatch } = this.props;
    let funcodeVue = this.state.dataSource.PublicDetilInfo[0].fundcode;
    dispatch(newgetPublicProductDetil(funcodeVue,()=>{ },this))
  }
  //涨跌幅颜色
  Coloroffluctuationrange=(val)=>{
    val =Number(val)
    let valColor = "#999999";
    if(val == 0) {
      valColor = "#999999";
    }else if(val < 0) {
      valColor = "#1DA96B";
    }else if(val > 0) {
      valColor = "#FA063A";
    }else {
      valColor = "#999999";
    }
    return valColor
  }
  //基金分析指标按钮
  FundAnalysis=(val)=>{
    if(this.state.dataSource.yearsOfFund>=5 && val == "近五年"){
      let { dispatch} = this.props;
      let parameter={
        fundCode:this.state.fundCode
      }
      dispatch(getFundAnalysisIndicatorOfFiveYears(parameter,(data) => { 
        this.setState({
          maxDownSideFiveYear:data.maxDownSideFiveYear,
          text:val
        })
       },));
    }else{
    this.setState({text:val})
    }
  }
  // 投资分布占比
  investmentallocation=(dataSource)=>{
    let investdata = [{},{},{},{}];
    let data=[]
    if(dataSource !=null){
     let data = dataSource.PublicDetilAsset;
     if(dataSource.riskLevelName == "低风险"){
       investdata[0].name = "股票" + " --";
       investdata[0].value = 0.00;
     }
     for(let i=0;i<data.length;i++){
       if(data[i].name === "其中：股票" || data[i].name === "其中：普通股"){
         investdata[0].name = "股票";
         investdata[0].value = newToFixed(data[i].rate)
       }else if(data[i].name ==="其中：债券"){
         investdata[1].name = "债券";
         investdata[1].value = newToFixed(data[i].rate)
       }else if(data[i].name === "银行存款和结算备付金合计"){
         investdata[2].name = "现金";
         investdata[2].value = newToFixed(data[i].rate)
       }else if(data[i].name === "其他各项资产"){
        investdata[3].name = "其他";
        investdata[3].value = newToFixed(data[i].rate)
      }
     }
     if(!investdata[0].name){
       investdata[0].name = "股票";
       investdata[0].value = 0
     }
     if(!investdata[1].name){
       investdata[1].name = "债券";
       investdata[1].value = 0
     }
     if(!investdata[2].name){
       investdata[2].name = "现金";
       investdata[2].value = 0
     }
     if(!investdata[3].name){
      investdata[3].name = "其他";
      investdata[3].value = 0
    }
    }
    investdata.map((item)=>{
      if(item.value > 0 ){
        data.push(item)
      }
    })
    data.sort((a, b) => {
      //  b-a 就是后边的值减前边的值 降序 
      return b.value - a.value
    })

    return data
  }
  //重仓占比对比
  Proportionofheavypositions=(data)=>{
    // PublicDetilStock 重仓股  PublicDetailFund 重仓基金 PublicDetilBond 重仓债   
    // compareToPrevious 较上期
    let text =""
    if(data!=null){
    let PublicDetilBondsum = {sum:0,tet:""}//重仓债
    let PublicDetilStocksum = {sum:0,tet:""}//重仓股
    let PublicDetailFundsum = {sum:0,tet:""}//重仓基金
    let Bondsum = 0
    let Stocksum = 0
    let Fundsum = 0
   data.PublicDetilBond.map((item)=>{
     Bondsum = Number((Bondsum -0) + Number(item.rate)).toFixed(2)
     PublicDetilBondsum = {sum:Number(Bondsum),tex:"重仓债券"}
   })
   data.PublicDetilStock.map((item)=>{
     Stocksum = Number((Stocksum -0) + Number(item.rate)).toFixed(2)
     PublicDetilStocksum = {sum:Number(Stocksum),tex:"重仓股票"}
   })
   data.PublicDetailFund.map((item)=>{
     Fundsum = Number((Fundsum -0) + Number(item.rate)).toFixed(2)
     PublicDetailFundsum = {sum:Number(Fundsum),tex:"重仓基金"}
   })
   // console.log(PublicDetilBondsum,PublicDetilStocksum,PublicDetailFundsum)
   let dataaaaa =[PublicDetilStocksum,PublicDetailFundsum,PublicDetilBondsum,]
   dataaaaa.sort((a, b) => {
     //  b-a 就是后边的值减前边的值 降序 
     return b.sum - a.sum
   })
   text=dataaaaa[0].tex
   }
   return text
 }
 dateformat=(data)=>{
   if(data !=null){
     var year = data.slice(0,4);
     var month = data.slice(4,6);
     var day = data.slice(6,9);
     return year + "-" + month + "-" + day;
   }
   return "--";
 }
 //指数切换
  productTypeCallback=(name,Code)=>{
    let {dispatch} = this.props
    let params = { fundCode:this.state.fundCode,symbolCode: Code, type:this.state.type}
    this.props.dispatch(Newpublicinterface(params, (data) => {
    let IndexData=this.datacl(data)
    this.changeEchartsData(this.state.tabVal, IndexData, this.state.selectTab,data.maxDrawDownValue)
    if(this.state.selectTab == "近一月"){
      this.setState({
        chartsDataArr: { ...this.state.chartsDataArr, oneMonth: IndexData } ,
        maxDrawDownArr:{ ...this.state.maxDrawDownArr, OneMonthmaxDrawDownValue:data.maxDrawDownValue},
    }) 
    }else if(this.state.selectTab == "近三月"){
      this.setState({
        chartsDataArr: { ...this.state.chartsDataArr, threeMonth: IndexData } ,
        maxDrawDownArr:{ ...this.state.maxDrawDownArr, ThreeMonthmaxDrawDownValue:data.maxDrawDownValue},
    }) 
    }else if(this.state.selectTab == "近六月"){
      this.setState({
        chartsDataArr: { ...this.state.chartsDataArr, sixMonth: IndexData } ,
        maxDrawDownArr:{ ...this.state.maxDrawDownArr, SixMonthmaxDrawDownValue:data.maxDrawDownValue},
    }) 
    }else if(this.state.selectTab == "近一年"){
      this.setState({
        chartsDataArr: { ...this.state.chartsDataArr, oneYear: IndexData } ,
        maxDrawDownArr:{ ...this.state.maxDrawDownArr,  OneYearmaxDrawDownValue:data.maxDrawDownValue},
    }) 
    }else if(this.state.selectTab == "近三年"){
      this.setState({
        chartsDataArr: { ...this.state.chartsDataArr, ThreeYear: IndexData } ,
        maxDrawDownArr:{ ...this.state.maxDrawDownArr, ThreeYearmaxDrawDownValue:data.maxDrawDownValue},
    }) 
    }else if(this.state.selectTab == "近五年"){
      this.setState({
        chartsDataArr: { ...this.state.chartsDataArr, fiveYear: IndexData } ,
        maxDrawDownArr:{ ...this.state.maxDrawDownArr, FiveYearmaxDrawDownValue:data.maxDrawDownValue},
    }) 
    }else if(this.state.selectTab == "今年以来"){
      this.setState({
        chartsDataArr: { ...this.state.chartsDataArr, thisyear: IndexData } ,
        maxDrawDownArr:{ ...this.state.maxDrawDownArr, ThisyearmaxDrawDownValue:data.maxDrawDownValue},
    }) 
    }else if(this.state.selectTab == "成立以来"){
      this.setState({
        chartsDataArr: { ...this.state.chartsDataArr, allData: IndexData } ,
        maxDrawDownArr:{ ...this.state.maxDrawDownArr, AllDatamaxDrawDownValue:data.maxDrawDownValue},
    }) 
    }
  }));
    this.setState({
      Basictext:name,
      symbolcode:Code,
      Basicfalg:false,
      OneMonthBasicffsa:false,
      ThreeMonthBasicffsa:false,
      SixMonthBasicffsa:false,
      OneYearBasicffsa:false,
      ThisyearBasicffsa:false,
      ThreeYearBasicffsa:false,
      FiveYearBasicffsa:false,
      AllDataBasicffsa:false,
    })
  }
  callService(){
    // OnlineService(this)
  }
  //基金经理时间判断
  sofar(mvenddate1){
    let mvenddate = new Date(mvenddate1).getTime()
    let mvend = new Date().getTime()
    if((mvenddate === mvend) || null){
      return "至今"
    }else{
      return mvenddate1
    }
  }
  goToProductSummaryPage=()=>{
    hashHistory.push({
      pathname: '/ProductSummary',
      state:{
        url:this.state.dataSource.cpzlgyUrl,
        navigator:hashHistory
      }
    });
  }
  goOfferingTranInfo(){
    hashHistory.push({
      pathname: '/PublicOfferingTranInfo',
      state: {
        fundCode:this.state.fundCode,
        isTaxDeferredProduct:this.state.isTaxDeferredProduct
      }
    });
  }
  goFundGk(val,isScroll=false){
    console.log(this.state.dataSource);
    hashHistory.push({
      pathname:'/newFundGk',
      state:{  
        invest:this.state.invest,
        fundcode:this.state.fundCode,
        dataSource:this.state.dataSource,
        // initialPage:val === "行业" ? 1:val === "公告" ?  2:val === "分红记录" ? 3:0,
        initialPage:val,
        isScroll,
        // dispatch:this.props.dispatch
      }
    })
  }
  goToManager=(fundCode,wdmanagerid,index)=>{
    hashHistory.push({
      pathname: '/NewManagerDetailSlidePage',
      state:{
        fundCode,
        wdmanagerid,
        index,
      }
    });
  }
  gcClassC(code,statecode){
    let scode =this.props.statecode|| ""
    if(code === scode){
      this.props.navigator.pop();

    }else{
      ClassfundFun(code,statecode,hashHistory);
    }
  }
  goBack(){
    hashHistory.goBack();
  }
  handleClick(key){
    this.setState({key})
  }
  timeTxt(currentDayIsWorkDay,currentTimeIsWorkTime){
    // console.log(currentDayIsWorkDay,currentTimeIsWorkTime,'123123123')
    if(currentDayIsWorkDay&&currentTimeIsWorkTime)return '今日15点前'
    if(currentDayIsWorkDay&&!currentTimeIsWorkTime)return '今日15点后'
    if(!currentDayIsWorkDay)return '今日'
  }
  onLearnMore = (url) => {
    this.props.navigator.push({
      pathname: '/NoticeListPdf',
      state: {
          downloadUrl: url,
      }
    })
  }
  OpenApp=(e)=>{
    const {fundCode} =this.state
    const u = navigator.userAgent;
    const Config = {
      /*scheme:必须*/
      // scheme: 'hxfapp://index/?component=NewPublicOffering&fundcode='+this.state.fundCode,
      download_url_IOS: "https://itunes.apple.com/cn/app/%E5%8D%8E%E5%A4%8F%E6%9F%A5%E7%90%86%E6%99%BA%E6%8A%95-%E5%8D%8E%E5%A4%8F%E5%9F%BA%E9%87%91%E6%97%97%E4%B8%8B%E6%99%BA%E8%83%BD%E6%8A%95%E9%A1%BE%E5%B9%B3%E5%8F%B0/id1310292772?mt=8",
      download_url_Adr: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.huaxiafortune',
      timeout: 2000,
      jump_url:"https://app.amcfortune.com/open-wapp?param=",
      hidden : window.document.hidden || window.document.mozHidden || window.document.msHidden ||window.document.webkitHidden 
    };
    const isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    // 微信内
    if(isWeixin) {
      this.setState({ showOverLay:true })
      return ;
 } 
  {
     //android端
     if (isAndroid) {
         //安卓app的scheme协议  
        //  window.location.href = Config.scheme;
        window.location.href = 'hxfapp://index/?param='+ JSON.stringify({ param1: fundCode, param2: 'GDetail'});
        // window.open = Config.scheme;
         setTimeout(function(){
             if(typeof Config.hidden ==="undefined" || Config.hidden ===false){
                 //应用宝下载地址 
                 window.location.href =Config.download_url_Adr
                }
         }, Config.timeout);
     }
     //ios端
     if (isIOS) { 
         //ios的scheme协议
        //  window.location.href = Config.scheme;
        // window.open = Config.scheme;

        //  setTimeout(function(){
        //      if(typeof Config.hidden ==="undefined" || Config.hidden ===false){
        //          //App store下载地址
        //         //  window.location.href =Config.download_url_IOS
        //         window.location.replace(Config.download_url_IOS)
        //       }
        //  }, Config.timeout);
        window.location.href =
         Config.jump_url +JSON.stringify({ param1: fundCode, param2: "GDetail" });
     }
 }
  }
  render() {
    let  {latestDividend,is_optional,dataSource,text,AccumulatedNet,Basicdata,invest,acRelationFundCode,latestPublicFundAnnouncement,relationFundName,dataInfo,Netperformance,buyTradeRule,PublicDetilBaseInfo,PublicDetilManager}=this.state
    // let Latestcopies=PublicDetilBaseInfo ? PublicDetilBaseInfo.lasttotal:null//份数 13是后面的日期加份的长度
    // let fen=Latestcopies=== null ? 0:Latestcopies.slice(0,Latestcopies.length - 13)
    // let Latestscale = dataInfo === null ? null:Util.priceParse(fen) * Number(dataInfo.fundvalue) //最新规模
    let chengli=this.state.chengli || ""//基金成立多少天
    let Latestcopies=PublicDetilBaseInfo ? PublicDetilBaseInfo.lasttotal:null//份数 13是后面的日期加份的长度
    let fen=Latestcopies=== null ? 0:Latestcopies.slice(0,Latestcopies.length - 13)
    let investdata=invest?invest:null//投资分布
    let Proport=this.Proportionofheavypositions(dataSource)//重仓占比
    let Proportdata=dataSource ? Proport === "重仓债券" ? dataSource.PublicDetilBond :Proport === "重仓股票" ?  dataSource.PublicDetilStock:Proport === "重仓基金" ?  dataSource.PublicDetailFund :null :null
    let acRelationname="" //a c类产品名
    let funname = ""
    if(dataInfo === null){
    acRelationname=""
    }else{
    if(dataInfo.fundtype === "货币型"){
      if(dataSource === null){
        acRelationname=""
        }else if(dataSource.fundShareClass==="A"){
        funname=dataInfo=== null ? "":dataInfo.fundname.slice(0,dataInfo.fundname.length - 1)
        acRelationname=funname+"B"
        }else if(dataSource.fundShareClass==="B"){
        funname=dataInfo=== null ? "":dataInfo.fundname.slice(0,dataInfo.fundname.length - 1)
        acRelationname=funname+"A"
        }
    }else{
      if(dataSource === null){
        acRelationname=""
        }else if(dataSource.fundShareClass==="A"){
        funname=dataInfo=== null ? "":dataInfo.fundname.slice(0,dataInfo.fundname.length - 1)
        acRelationname=funname+"C"
        }else if(dataSource.fundShareClass==="C"){
        funname=dataInfo=== null ? "":dataInfo.fundname.slice(0,dataInfo.fundname.length - 1)
        acRelationname=funname+"A"
        }
    }
    }
    let _fxColor = "#FF8026";
    let biaotiyanse={
      "股票":{
        imgurl:require("../../../imgs/ziqita.png"),
        fontColor:'#7361F4'
      },
      "债券":{
        imgurl:require("../../../imgs/yinhang.png"),
        fontColor:'#FF8026'
      },
      "现金":{
        imgurl:require("../../../imgs/zhaiquan.png"),
        fontColor:'#F92C3D'
      },
      "其他":{
        imgurl:require("../../../imgs/lanqita.png"),
        fontColor:'#407BE7'
      },
      '基金':{
        imgurl:require("../../../imgs/jijin.png"),
        fontColor:'#37ABEE'
      }
    }
    let tabList = [];
    if(dataInfo != null ){
      if (dataInfo.fundtype === "货币型") {
        tabList =  [ "七日年化", "万份收益"];
      }else{
        tabList =  ["业绩走势", "单位净值","累计净值"];
      }
    }
    let historyList =["历史业绩", "历史净值"]
    if(dataInfo === null){
      historyList=["历史业绩", "历史净值"]
    }else if(dataInfo.fundtype === "货币型"){
      historyList=["历史业绩", "历史收益"]
    }else{
      historyList=["历史业绩", "历史净值"]
    }
    let fundAnalysisIndicatorFlag=dataSource? dataSource.fundAnalysisIndicatorFlag:null
    let _this=this;
    let productTypeListContent = [];
    Basicdata ? Basicdata.map(function(itme,i){
      productTypeListContent.push({title: itme.symbolName,code:itme.symbolCode , callback: ()=>{_this.productTypeCallback(itme.symbolName,itme.symbolCode)} })
    }) : null
    return (
      <div className="container" style={{background:'#fff',display:'flex',flexDirection:'column'}}  >
       {/* {this.openOverLay()} */}
       { this.state.showOverLay &&
          <div onClick={()=> this.setState({ showOverLay:false })}>
            <div style={{ position: 'relative'}}></div>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor:' rgba(0, 0, 0, 0.5)',/* 半透明黑色 */
                zIndex: 99999999 /* 保证遮罩层在其他内容之上 */
              }} >
                <img src={require('../../../imgs/OpenBrowser.jpg')} width='100%' height='auto' />
            </div>
          </div>
      }
        <div className="header" id='header' style={{ position:'relative',backgroundColor: '#fff',background:`url(${headerImg}) repeat-x`,backgroundSize:'cover'}}>
          <div></div>
          <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:150 }}>
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden',textOverflow: 'ellipsis'}} >{dataInfo ? dataInfo.fundname :"--"}</span>
          </div>
          <div></div>
        </div>

        <div id='scrollView' style={{flex:1,overflow:'auto'}}>
          <div style={{width:'100%',position:'relative'}}>
            <div style={{heighe:160,background:`url(${require('../../../imgs/headerImg.png')}) repeat-x`,backgroundSize:'cover',backgroundPosition:' 0 -136px'}}>
              <div style={{boxShadow:'0 1px 1px rgba(0, 0, 0, 0.10)',marginBottom:5,background:'#fff',borderRadius:10,marginLeft:20,marginRight:20,paddingBottom:15}}>
                <div style={{paddingTop:17,paddingLeft:15,marginBottom:23,background:`url(${fundHeader}) no-repeat 0 0/100% auto`}}>
                  <div style={{color:'#333',fontWeight:500,lineHeight:'22px',fontSize:18,marginBottom:10}}>{dataInfo ? dataInfo.fundname?dataInfo.fundname :"--" :"--"}</div>
                  <div style={{display:'flex',alignItems:'center'}}>
                    <div style={{fontSize:16,lineHeight:'16px',color:'#999',marginRight:10}}>{dataInfo ? dataInfo.fundcode?dataInfo.fundcode :"--":"--"}</div>
                    <div style={{fontSize:12,color:'#999999',border:'1px solid #999999',padding:1,marginRight:10}}>{dataInfo ? dataInfo.fundtype? dataInfo.fundtype :"--":"--"}</div>
                    <div style={{fontSize:12,color:'#FF8026',border:'1px solid #FF8026',padding:1}}>{dataSource ? dataSource.riskLevelName?dataSource.riskLevelName:"--":"--"}{dataSource ? dataSource.riskLevel?"R"+dataSource.riskLevel:"--":"--"}</div>
                  </div>
                </div>
                {
                  dataInfo && dataInfo.fundtype === "货币型"?
                    <div style={{display:'flex',paddingLeft:15,paddingRight:15,justifyContent:'space-between'}}>
                      <div style={{flex:1}}>
                        <div style={{fontSize:24,marginBottom:5,color:dataInfo ? this.Coloroffluctuationrange(dataInfo.qirinianhua):"#999999",fontFamily:'DINAlternate-Bold'}}>{dataInfo.qirinianhua ? dataInfo.qirinianhua > 0 ? "+"+Util.Retainfourdecimalplaces(dataInfo.qirinianhua)+"%":Util.Retainfourdecimalplaces(dataInfo.qirinianhua)+"%" :"--"}</div>
                        <div style={{...styles.font12999}}>七日年化({dataInfo.publish_date ? (dataInfo.publish_date).slice(5,10):"--"})</div>
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontSize:24,textAlign:'center',marginBottom:5,color:"#333",fontFamily:'DINAlternate-Bold'}}>{dataInfo.wanfenshouyi ? dataInfo.wanfenshouyi:"--"}</div>
                        <div style={{...styles.font12999,textAlign:'center'}}>万份收益(元)</div>
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontSize:24,textAlign:'center',marginBottom:5,color:dataInfo ? this.Coloroffluctuationrange(Netperformance.yearnavchgrate):"#999999",fontFamily:'DINAlternate-Bold'}}>{Netperformance ? Util.keepfomatFloat(Netperformance.yearnavchgrate):"--" }</div>
                        <div style={{...styles.font12999,textAlign:'center'}}>今年以来收益率</div>
                      </div>
                    </div>
                  :
                    <div style={{display:'flex',paddingLeft:15,paddingRight:15,justifyContent:'space-between'}}>
                      <div style={{flex:1}}>
                        <div style={{fontSize:24,marginBottom:5,color:AccumulatedNet.length>0  ? this.Coloroffluctuationrange(AccumulatedNet[0].value_zdf):"#999999",fontFamily:'DINAlternate-Bold'}}>{AccumulatedNet.length > 0 ? Util.keepfomatFloat(AccumulatedNet[0].value_zdf):"--"}</div>
                        <div style={{...styles.font12999}}>日涨跌幅({(dataInfo && (dataInfo.publish_date).slice(5,10))||"--"})</div>
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontSize:24,textAlign:'center',marginBottom:5,color:'#333',fontFamily:'DINAlternate-Bold'}}>{(dataInfo &&dataInfo.fundvalue)||"--"}</div>
                        <div style={{...styles.font12999,textAlign:'center'}}>单位净值</div>
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontSize:24,textAlign:'center',marginBottom:5,color:'#333',fontFamily:'DINAlternate-Bold'}}>{(dataInfo&&dataInfo.leijijingzhi)||"--"}</div>
                        <div style={{...styles.font12999,textAlign:'center'}}>累计净值</div>
                      </div>
                    </div>
                }
                {/* 排名 */}
                {/* <div style={{paddingLeft:15,paddingRight:15,paddingBottom:10}}>
                  <div style={{height:1,marginBottom:10,background:'#EFF0F4'}}></div>
                  <div style={{display:'flex',alignItems:'center'}}>
                    <img src={require('../../../imgs/paiming.png')} style={{height:14,width:14,marginRight:5}} alt='' />
                    <div style={{color:'#999999',fontSize:'.2rem'}}>近一年收益率同类排名172/1345</div>
                  </div>
                </div> */}
            </div>
            </div>
            {/* 走势区域 */}
            <div style={{background:'#fff',paddingBottom:10}}>
              {/* 营销语 */}
              {
                dataSource?
                  dataSource.marketingConfig?
                    <div onClick={()=>this.OpenApp()} style={{marginTop:10,marginLeft:20,marginRight:20,display:'flex',alignItems:'center',height:34,background:`url(${yingxiao}) no-repeat`,backgroundSize:'cover'}}>
                      <div style={{fontSize:12,color:'#ED364F',marginRight:5,marginLeft:15,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{dataSource.marketingConfig.marketingClaims}</div>
                      <img src={require('../../../imgs/bianzu4.png')} style={{height:10,width:18}} alt='' />
                    </div>
                  :null
                :null
              } 
              <div id='echartsbox' style={{display:'flex',paddingTop:20,paddingLeft:20,paddingRight:20,marginBottom:10}}>  
                {
                  tabList.map((item,index)=>{
                    let fontColorName = index+1+'' === this.state.key ? "b1" : "b2"
                    let lineColor = index+1+'' === this.state.key ? "activeLine" : "notActiveLine"
                    return(
                      <div key={index+1+''} onClick={()=>{this.handleClick(index+1+'');this.tabValFun(item,index)}} style={{display:'flex',lineHeight:'16px',flexDirection:'column',justifyContent:'center',alignItems:'center',marginRight:25}}>
                        <div style={{...styles[fontColorName],marginBottom:8}}>{item}</div>
                        <div style={{...styles[lineColor],height:3,width:28,borderRadius:2}}></div>
                      </div>
                    )
                  })
                }
              </div> 
              <EchartsBox
                _thisObj={this}
                _selectTab={this.state.selectTab}
                _tabVal={this.state.tabVal}

                _profitNav={this.state.profitNav}
                _profitData={this.state.profitData}

                onRef={this.onRef}
                newDatas = {this.state.newDatas}
                newNevs = {this.state.newNevs}
                newNev = {this.state.newNev}
                newData = {this.state.newData}
                allIncome = {this.state.allIncome}
                Lineval = {this.state.Lineval}
                Basicfalg ={this.state.Basicfalg}
                Basicback ={()=>this.setState({Basicfalg:!this.state.Basicfalg})}
                Basictext= {this.state.Basictext}
              />
              {/* <Tabs 
                defaultActiveKey="1"
                swipeable={false}
                type="card" 
                animated={false}
                activeKey={this.state.key}
                renderTabBar={() => {
                  return(
                    <div style={{display:'flex',marginTop:10,paddingLeft:20,paddingRight:20}}>
                      {
                        tabList.map((item,index)=>{
                          let fontColorName = index+1+'' === this.state.key ? "b1" : "b2"
                          let lineColor = index+1+'' === this.state.key ? "activeLine" : "notActiveLine"
                          return(
                            <div key={index+1+''} onClick={()=>{this.handleClick(index+1+'');this.tabValFun(item,0)}} style={{display:'flex',lineHeight:'16px',flexDirection:'column',justifyContent:'center',alignItems:'center',marginRight:25}}>
                              <div style={{...styles[fontColorName],marginBottom:8}}>{item}</div>
                              <div style={{...styles[lineColor],height:3,width:28,borderRadius:2}}></div>
                            </div>
                          )
                        })
                      }
                    </div> 
                  )
                }}
              >
                {
                  tabList.map((item,index)=>{
                    return(
                      <TabPane tab='' key={index+1+''}>
                        <EchartsBox
                          keys={index}
                          _thisObj={this}
                          _selectTab={this.state.selectTab}
                          _tabVal={this.state.tabVal}
                          _buyDateList={this.state.buyDateList}
                          _redeemDateList={this.state.redeemDateList}

                          _newbuyDateList={this.state.newbuyDateList}
                          _newredeemDateList={this.state.newredeemDateList}
                          _dividendDateList={this.state.dividendDateList}

                          _profitNav={this.state.profitNav}
                          _profitData={this.state.profitData}
                          onRef={this.onRef}
                          newDatas = {this.state.newDatas}
                          newNevs = {this.state.newNevs}
                          newNev = {this.state.newNev}
                          newData = {this.state.newData}
                          allIncome = {this.state.allIncome}
                          Lineval = {this.state.Lineval}
                          Basicfalg ={this.state.Basicfalg}
                          Basicback ={()=>this.setState({Basicfalg:!this.state.Basicfalg})}
                          Basictext= {this.state.Basictext}
                        />
                      </TabPane>
                    )
                  })
                }
              </Tabs> */}
              <div style={{ marginLeft:20,marginRight:20, backgroundColor: "#fff", height:30,borderRadius: 6,border:"1px solid #DFDFDF",display:'flex',alignItems: 'center'}}>
                <div onClick={() => {this.selectTabFun("近1月") }}  style={{ flex: 1, height: 30, display:'flex',justifyContent: "center", alignItems: "center",borderRight:'1px solid #DFDFDF'}}>
                  <div style={{ color: this.state.selectTab == "近1月" ? "#B69271" : "#3C3C3C", fontSize: 12 }}>近1月</div>
                </div>
                <div onClick={() => {this.selectTabFun("近3月") }}  style={{ flex: 1, height: 30, display:'flex',justifyContent: "center", alignItems: "center",borderRight:'1px solid #DFDFDF' }}>
                  <div style={{ color: this.state.selectTab == "近3月" ? "#B69271" : "#3C3C3C", fontSize: 12 }}>近3月</div>
                </div>
                <div onClick={() => {this.selectTabFun("近6月") }}  style={{ flex: 1, height: 30, display:'flex',justifyContent: "center", alignItems: "center",borderRight:'1px solid #DFDFDF' }}>
                  <div style={{ color: this.state.selectTab == "近6月" ? "#B69271" : "#3C3C3C", fontSize: 12 }}>近6月</div>
                </div>
                <div onClick={() => {this.selectTabFun("近1年") }}  style={{ flex: 1, height: 30, display:'flex',justifyContent: "center", alignItems: "center",borderRight:'1px solid #DFDFDF' }}>
                  <div style={{ color: this.state.selectTab == "近1年" ? "#B69271" : "#3C3C3C", fontSize: 12 }}>近1年</div>
                </div>
                <div onClick={() => {this.setState({selectOther:true})}} style={{ flex: 1, height: 30,display:'flex',justifyContent: "center", alignItems: "center", }}>
                  <div style={{ color: this.state.selectTab == "更多" ? "#B69271" : "#3C3C3C", fontSize: 12 }}>更多</div>
                    {
                      this.state.selectOther === false ? 
                        <img style={{width:8,height:8}} src={require('../../../imgs/icon_xiala.png')}/>
                      :
                        <img style={{width:8,height:8}} src={require('../../../imgs/icon_xlqhx.png')}/>
                    }
                  </div>
                </div>
            </div>
            
            <div style={{height:10,background:'#F5F6F7'}}></div>
            {/* 历史业绩 */}
            <div id='history' style={{paddingTop:15,paddingLeft:20,paddingRight:20,background:'#fff'}}>
              <HistoryList AccumulatedNet={AccumulatedNet} historyList={historyList} Netperformance={Netperformance} dataSource={dataSource} dataInfo={dataInfo}/>
            </div>
            <div style={{height:10,background:'#F5F6F7'}}></div>
            {/* 基金分析指标 */}
            {
              fundAnalysisIndicatorFlag === true && dataInfo.fundtype != "货币型"?
                <div style={{...styles.box}}>
                  <div style={{display:'flex',alignItems:'center',marginBottom:20}}>
                    <div style={{...styles.font16333,marginRight:5}}>基金分析指标</div>
                    <div style={{background:'#F0F0F0',display:'flex',padding:4,borderRadius:11}}>
                      <div 
                        style={{paddingLeft:4,paddingRight:4,color:text === "近一年"? '#fff':'#999',background:text === "近一年"? "#F92C3D":'transparent',fontSize:12,textAlign:'center',lineHeight:'17px',borderRadius:8}}
                        onClick={()=>this.FundAnalysis("近一年")}
                      >
                          近一年
                        </div>
                      <div 
                        style={{paddingLeft:4,paddingRight:4,color:text === "近三年"? '#fff':'#999',background:text === "近三年"? "#F92C3D":'transparent',fontSize:12,textAlign:'center',lineHeight:'17px',borderRadius:8,marginLeft:4}}
                        onClick={()=>this.FundAnalysis("近三年")}
                      >
                          近三年
                        </div>
                      <div 
                        style={{paddingLeft:4,paddingRight:4,color:text === "近五年"? '#fff':'#999',background:text === "近五年"? "#F92C3D":'transparent',fontSize:12,textAlign:'center',lineHeight:'17px',borderRadius:8,marginLeft:4}}
                        onClick={()=>this.FundAnalysis("近五年")}
                      >
                          近五年
                        </div>
                    </div>
                  </div>
                  {
                    Netperformance?
                    <div>
                        {
                          text==="近一年" ?
                            <div style={{display:'flex',alignItems:'center',justifyContent:'space-around'}}>
                              <div style={{background:'#FBFBFB',height:62,width:110,display:'flex',justifyContent:'center',alignItems:"center",flexDirection:'column'}}>
                                <div style={{color:'#333333',fontSize:16}}>{Netperformance.volatilityYear == 0 ? "--":Util.fomatFloat(Netperformance.volatilityYear)}</div>
                                <div style={{display:'flex',alignItems:'center'}}>
                                  <div style={{...styles.font12999}}>波动率</div>
                                  <img onClick={()=>{this.setState({tipIntroduce:true})}} src={require('../../../imgs/icon-xiaoitishi.png')} style={{height:16,width:16}} alt='' />
                                </div>
                              </div>
                              <div style={{background:'#FBFBFB',height:62,width:110,display:'flex',justifyContent:'center',alignItems:"center",flexDirection:'column'}}>
                                <div style={{color:'#333333',fontSize:16}}>{Netperformance.sharpRatioYear == 0 ? "--":Util.fomatFloat(Netperformance.sharpRatioYear)}</div>
                                <div style={{display:'flex',alignItems:'center'}}>
                                  <div style={{...styles.font12999}}>夏普比率</div>
                                  <img onClick={()=>{this.setState({tipIntroduce:true})}} src={require('../../../imgs/icon-xiaoitishi.png')} style={{height:16,width:16}} alt='' />
                                </div>
                              </div>
                              <div style={{background:'#FBFBFB',height:62,width:110,display:'flex',justifyContent:'center',alignItems:"center",flexDirection:'column'}}>
                                <div style={{color:'#333333',fontSize:16}}>{Netperformance.maxDownSideYear == 0 ? "--":Util.fomatFloat(Netperformance.maxDownSideYear)}</div>
                                <div style={{display:'flex',alignItems:'center'}}>
                                  <div style={{...styles.font12999}}>最大回撤</div>
                                  <img onClick={()=>{this.setState({tipIntroduce:true})}} src={require('../../../imgs/icon-xiaoitishi.png')} style={{height:16,width:16}} alt='' />
                                </div>
                              </div>
                            </div>
                          :
                          null
                        }
                        {
                          text === '近三年' ?
                            <div>
                              {
                                dataSource.yearsOfFund >=3 ?
                                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-around'}}>
                                    <div style={{background:'#FBFBFB',height:62,width:110,display:'flex',justifyContent:'center',alignItems:"center",flexDirection:'column'}}>
                                      <div style={{color:'#333333',fontSize:16}}>{Netperformance.volatilityThreeYear == 0 ? "--":Util.fomatFloat(Netperformance.volatilityThreeYear)}</div>
                                      <div style={{display:'flex',alignItems:'center'}}>
                                        <div style={{...styles.font12999}}>波动率</div>
                                        <img onClick={()=>{this.setState({tipIntroduce:true})}} src={require('../../../imgs/icon-xiaoitishi.png')} style={{height:16,width:16}} alt='' />
                                      </div>
                                    </div>
                                    <div style={{background:'#FBFBFB',height:62,width:110,display:'flex',justifyContent:'center',alignItems:"center",flexDirection:'column'}}>
                                      <div style={{color:'#333333',fontSize:16}}>{Netperformance.sharpRatioThreeYear == 0 ? "--":Util.fomatFloat(Netperformance.sharpRatioThreeYear)}</div>
                                      <div style={{display:'flex',alignItems:'center'}}>
                                        <div style={{...styles.font12999}}>夏普比率</div>
                                        <img onClick={()=>{this.setState({tipIntroduce:true})}} src={require('../../../imgs/icon-xiaoitishi.png')} style={{height:16,width:16}} alt='' />
                                      </div>
                                    </div>
                                    <div style={{background:'#FBFBFB',height:62,width:110,display:'flex',justifyContent:'center',alignItems:"center",flexDirection:'column'}}>
                                      <div style={{color:'#333333',fontSize:16}}>{Netperformance.maxDownSideThreeYear == 0 ? "--":Util.fomatFloat(Netperformance.maxDownSideThreeYear)}</div>
                                      <div style={{display:'flex',alignItems:'center'}}>
                                        <div style={{...styles.font12999}}>最大回撤</div>
                                        <img onClick={()=>{this.setState({tipIntroduce:true})}} src={require('../../../imgs/icon-xiaoitishi.png')} style={{height:16,width:16}} alt='' />
                                      </div>
                                    </div>
                                  </div>
                                :
                                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-around',height:62,color:'#999',fontSize:12}}>
                                    成立时间不足，暂无数据；
                                  </div>
                              }
                            </div>
                          :
                            null
                        }
                        {
                          text === '近五年' ?
                            <div>
                              {
                                dataSource.yearsOfFund >=5 ?
                                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-around'}}>
                                    <div style={{background:'#FBFBFB',height:62,width:110,display:'flex',justifyContent:'center',alignItems:"center",flexDirection:'column'}}>
                                      <div style={{color:'#333333',fontSize:16}}>{Netperformance.volatilityThreeYear == 0 ? "--":Util.fomatFloat(Netperformance.volatilityThreeYear)}</div>
                                      <div style={{display:'flex',alignItems:'center'}}>
                                        <div style={{...styles.font12999}}>波动率</div>
                                        <img onClick={()=>{this.setState({tipIntroduce:true})}} src={require('../../../imgs/icon-xiaoitishi.png')} style={{height:16,width:16}} alt='' />
                                      </div>
                                    </div>
                                    <div style={{background:'#FBFBFB',height:62,width:110,display:'flex',justifyContent:'center',alignItems:"center",flexDirection:'column'}}>
                                      <div style={{color:'#333333',fontSize:16}}>{Netperformance.sharpRatioThreeYear == 0 ? "--":Util.fomatFloat(Netperformance.sharpRatioThreeYear)}</div>
                                      <div style={{display:'flex',alignItems:'center'}}>
                                        <div style={{...styles.font12999}}>夏普比率</div>
                                        <img onClick={()=>{this.setState({tipIntroduce:true})}} src={require('../../../imgs/icon-xiaoitishi.png')} style={{height:16,width:16}} alt='' />
                                      </div>
                                    </div>
                                    <div style={{background:'#FBFBFB',height:62,width:110,display:'flex',justifyContent:'center',alignItems:"center",flexDirection:'column'}}>
                                      <div style={{color:'#333333',fontSize:16}}>{Netperformance.maxDownSideThreeYear == 0 ? "--":Util.fomatFloat(Netperformance.maxDownSideThreeYear)}</div>
                                      <div style={{display:'flex',alignItems:'center'}}>
                                        <div style={{...styles.font12999}}>最大回撤</div>
                                        <img onClick={()=>{this.setState({tipIntroduce:true})}} src={require('../../../imgs/icon-xiaoitishi.png')} style={{height:16,width:16}} alt='' />
                                      </div>
                                    </div>
                                  </div>
                                :
                                <div style={{display:'flex',alignItems:'center',justifyContent:'space-around',height:62,color:'#999',fontSize:12}}>
                                  成立时间不足，暂无数据；
                                </div>
                              }
                            </div>
                          :
                            null
                        }
                      </div>
                    :
                      null
                  }
                </div>
              :
                null
            }
            {
              Netperformance?
              <div style={{height:10,background:'#F5F6F7'}}></div>
              :null
            }
            {/* 交易信息 */}
            <div id='rule' style={{...styles.box}}>
              <div style={{display:'flex',alignItems:'center',marginBottom:20}}>
                <div style={{...styles.font16333}}>交易信息</div>
                {/* <div onClick={()=>this.goOfferingTranInfo()} style={{...styles.font12999}}>
                  费率、买入卖出规则
                  <img src={require('../../../imgs/icon_arraw_right_gray.png')} style={{height:10,width:10}} alt='' />
                </div> */}
              </div>
              <div style={{paddingBottom:15,paddingLeft:10,display:'flex',justifyContent:'space-between'}}>
                <div style={{flex:1,display:'flex',flexDirection:'column'}}>
                    <div style={styles.font12666}>买入</div>
                    <div style={{marginTop:4,marginBottom:4,display:'flex',alignItems:'center'}}>
                        <div style={styles.redRound}></div>
                        <div style={{height:1,backgroundColor:'#FFE5E7',flex:1}}></div>
                    </div>
                    <div style={styles.font12999}>{(buyTradeRule&&this.timeTxt(buyTradeRule.currentDayIsWorkDay,buyTradeRule.currentTimeIsWorkTime))||""}</div>
                </div>

                <div style={{textAlign:'center',flex:2}}>
                    <div style={styles.font12666}>确认份额</div>
                    <div style={{marginTop:4,marginBottom:4,display:'flex',alignItems:'center'}}>
                        <div style={{height:1,backgroundColor:'#FFE5E7',flex:1}}></div>
                        <div style={styles.redRound}></div>
                        <div style={{height:1,backgroundColor:'#FFE5E7',flex:1}}></div>
                    </div>
                  <div style={styles.font12999}>{(buyTradeRule&&`${buyTradeRule.confirmDate.slice(-5)}(${buyTradeRule.confirmDateWeekDay||'--'})`)|| "--"}</div>
                </div>

                <div style={{flex:2,textAlign:'right'}}>
                    <div style={styles.font12666}>查看盈亏</div>
                        <div style={{marginTop:4,marginBottom:4,display:'flex',alignItems:'center'}}>
                            <div style={{height:1,backgroundColor:'#FFE5E7',flex:1}}></div>
                            <div style={styles.redRound}></div>
                        </div>
                    <div style={styles.font12999}>{(buyTradeRule&&`${buyTradeRule.incomeOrAssetReturnDate.slice(-5)}净值更新后`)|| "--"}</div>
                </div>
              </div>
            </div>
            <div style={{height:10,background:'#F5F6F7'}}></div>
            {/* 基金档案 */}
            <div id='files' style={{...styles.box}}>
              <div style={{display:'flex',alignItems:'center',marginBottom:15}}>
                <div style={{...styles.font16333}}>基金档案</div>
                {/* {
                  dataInfo && dataInfo.fundtype === "货币型" ?
                    <div onClick={()=>this.goFundGk("基金概况")} style={{...styles.font12999}}>
                      概况、持仓、规模
                      <img src={require('../../../imgs/icon_arraw_right_gray.png')} style={{height:10,width:10}} alt='' />
                    </div>
                  :
                    <div onClick={()=>this.goFundGk("基金概况")} style={{...styles.font12999}}>
                      概况、持仓、规模、分红
                      <img src={require('../../../imgs/icon_arraw_right_gray.png')} style={{height:10,width:10}} alt='' />
                    </div>
                } */}
              </div>
              <div style={{fontSize:14,color:'#999',marginBottom:15}}>
                基金公司：
                <span style={{color:'#333'}}>{(PublicDetilBaseInfo&&PublicDetilBaseInfo.fundManager)||"--"}</span>
              </div>
              <div style={{display:'flex',marginBottom:15,justifyContent:'space-between'}}>
                {

                }
                <div style={{fontSize:14,color:'#999'}}>
                  最新规模：
                  <span style={{color:'#333'}}>{(PublicDetilBaseInfo && PublicDetilBaseInfo.finalFundAssetNavStr)||"--"}</span>
                </div>
                <div style={{fontSize:14,color:'#999',paddingRight:10}}>
                  成立日期：
                  <span style={{color:'#333'}}>{(PublicDetilBaseInfo&&PublicDetilBaseInfo.fundstartdate)||"--"}</span>
                </div>
              </div>
              <div style={{height:1,marginBottom:10,background:'#EFF0F4'}}></div>
              {/* 基金经理 */}
              <div style={{display:'flex',alignItems:'center',marginBottom:15}}>
                <div style={{...styles.font14666}}>基金经理</div>
                {/* <img onClick={()=>this.goToManager(dataInfo.fundcode,"",0)} src={require('../../../imgs/icon_arraw_right_gray.png')} style={{height:10,width:10}} alt='' /> */}
              </div>
              {
                PublicDetilManager && PublicDetilManager.map((item,index)=>{
                  return(
                    // <div key={index+''} onClick={()=>{ this.goToManager(dataInfo.fundcode,item.wdmanagerid,index) } } style={{...styles.box,marginBottom:15,background:`url(${require("../../../imgs/jijinjinglibeijing.png")}) repeat-x`,backgroundSize:'cover'}}>
                    <div key={index+''} style={{...styles.box,marginBottom:15,background:`url(${require("../../../imgs/jijinjinglibeijing.png")}) repeat-x`,backgroundSize:'cover'}}>
                      <div style={{marginBottom:12,display:'flex',alignItems:'flex-end'}}>
                        <span style={{fontSize:16,color:'#985119',marginRight:5,fontWeight:500}}>{item.name||"--"}</span>
                        {
                          item.periodOfOperationStr ?
                            <span style={{fontSize:12,color:'#A1612C',marginRight:5}}>从业{item.periodOfOperationStr||"--"}</span>
                          :
                            null
                        }
                      </div>
                      <div style={{display:'flex',justifyContent:'space-between'}}>
                        <div style={{display:'flex',flexDirection:'column'}}>
                          <div style={{marginBottom:4}}>
                            <span style={{...styles.font14119,marginRight:10,fontWeight:500}}>{item.startdate||"--"} - 至今</span>
                            <span style={{fontSize:12,color:'#985119',marginRight:10}}>{item.daysStr}</span>
                          </div>
                          <div style={{fontSize:12,color:'#DBBEA6'}}>本基金任期</div>
                        </div>
                        <div>
                          <div style={{...styles.font14119,marginBottom:4,fontWeight:500,fontFamily:'DINAlternate-Bold'}}>{item.managerincome ? item.managerincome > 0? "+"+item.managerincome+"%":item.managerincome+"%":"--"}</div>
                          <div style={{fontSize:12,color:'#DBBEA6'}}>任期内回报</div>
                        </div>
                      </div>
                      <img src={require('../../../imgs/bianzu6.png')} style={{height:20,marginTop:10}} alt='' />
                      <div style={{...styles.font12119,overflow:'hidden',lineHeight:'17px',textOverflow:'ellipsis',display:'-webkit-box',wordBreak:' break-all',WebkitBoxOrient:'vertical',WebkitLineClamp:2}}>
                        {item.resume||"--"}
                      </div>
                    </div>
                  )
                })
              }
              
              <div style={{height:1,marginBottom:10,background:'#EFF0F4'}}></div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:15}}>
                <div style={{...styles.font14666}}>投资分布</div>
                <div style={{...styles.font12999,fontFamily:'DINAlternate-Bold'}}>
                  {(dataSource&&dataSource.PublicDetilAsset[0]&&dataSource.PublicDetilAsset[0].reportenddate)|| "--"}
                  {/* <img src={require('../../../imgs/icon_arraw_right_gray.png')} style={{height:10,width:10}} alt='' /> */}
                </div>
              </div>
              <div style={{display:'flex',marginBottom:10}}>
                {
                  investdata && investdata.map((item,index)=>{
                    return(
                      <div key={index+''} style={{flex:1,height:63,paddingTop:13,paddingLeft:6,paddingBottom:13,marginRight:5,background:`url(${biaotiyanse[item.name].imgurl}) repeat-x`,backgroundSize:'cover'}}>
                        <div style={{fontSize:16,color:biaotiyanse[item.name].fontColor,textAlign:'left',marginBottom:4,fontFamily:'DINAlternate-Bold'}}>{item.ratePercent || "--"}</div>
                        <div style={{fontSize:12,color:'#00000063',textAlign:'left'}}>{item.name|| "--"}</div>
                      </div>
                    )
                  })
                }
              </div>
              {
                this.state.sum > 100?
                  <div style={{...styles.font12999,display:'flex',justifyContent:'flex-end',alignItems:'center',marginBottom:10}}>
                    为什么比例超过100%
                    <img onClick = {()=>{this.setState({investflag:true})}} src={require('../../../imgs/icon-xiaoitishi.png')} style={{height:12,width:12}} alt='' />
                  </div>
                :
                  null
              }
              {
                Proportdata?
                  <div style={{paddingLeft:15,paddingTop:15,paddingRight:8,borderRadius:5,paddingBottom:2,background:`url(${require('../../../imgs/zhongcang.png')}) repeat-x`,backgroundSize:'cover'}}>
                    <div style={{fontSize:14,color:'#333',marginBottom:15}}>
                      {Proport|| "--"}
                    </div>
                    <div style={{display:'flex',justifyContent:'space-between'}}>
                      {
                        Proport === "重仓股票"?
                          <div style={{...styles.font12999,marginBottom:10,flex:1}}>股票名称</div>
                        :
                          null
                      }
                      {
                        Proport === "重仓基金"?
                          <div style={{...styles.font12999,marginBottom:10,flex:1}}>基金名称</div>
                        :
                          null
                      }
                      {
                        Proport === "重仓债券"?
                          <div style={{...styles.font12999,marginBottom:10,flex:1}}>债卷名称</div>
                        :
                          null
                      }   
                      <div style={{...styles.font12999,marginLeft:12,marginRight:12,textAlign:'center',width:50}}>持仓占比</div>
                      <div style={{...styles.font12999,marginLeft:12,marginRight:12,textAlign:'right',width:50}}>较上期</div>
                    </div>
                    {
                      Proportdata.map((item,index)=>{
                        return(
                          <div key={index+''} style={{display:'flex',justifyContent:'space-between',marginBottom:10}}>
                            <div style={{...styles.font14666,flex:1,overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis'}}>{item.holdFundName? item.holdFundName:item.name|| "--"}</div>
                            <div style={{fontSize:14,color:'#666',marginLeft:12,marginRight:12,textAlign:'center',width:50,fontFamily:'DINAlternate-Bold'}}>{item.rate + "%"|| "--"}</div>
                            {
                              item.comparedToPrevious === null || item.comparedToPrevious ?
                                <div style={{display:'flex',alignItems:"center",justifyContent:"flex-end",marginLeft:12,marginRight:12,width:50}}>
                                  {
                                    item.comparedToPrevious === "新增" ?
                                      <div style={{color:"#666",fontWeight:"500",fontSize:12}}>新增</div>
                                    :
                                      <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                                        {
                                          item.comparedToPrevious === null || item.comparedToPrevious === "--" || item.comparedToPrevious === "0.00" ? null:item.comparedToPrevious > 0 ?
                                            <img alt='' src={require('../../../imgs/iconiantoushangsheng.png')} />
                                          :
                                            <img alt='' src={require('../../../imgs/iconjiantouxiajiang.png')} />
                                        }
                                        <div style={{fontSize:14,color:'#666',textAlign:'center',fontFamily:'DINAlternate-Bold'}}>{item.comparedToPrevious === "--" ? item.comparedToPrevious:item.comparedToPrevious !== null ? Util.keepfomatFloat(item.comparedToPrevious):"--"}</div>
                                      </div>
                                  }
                                </div>
                              :
                                <div style={{display:'flex',alignItems:"center",justifyContent:"center",marginLeft:12,marginRight:12,width:50}}>
                                  {
                                    item.compareToPrevious === "新增" ?
                                      <div style={{color:"#666",fontWeight:"500",fontSize:12}}>新增</div>
                                    :
                                      <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                                        {
                                          item.compareToPrevious === null || item.compareToPrevious === "--" || item.compareToPrevious === "0.00"? null:item.compareToPrevious > 0 ?
                                            <img alt='' src={require('../../../imgs/iconiantoushangsheng.png')} />
                                          :
                                            <img alt='' src={require('../../../imgs/iconjiantouxiajiang.png')} />
                                        }
                                        <div style={{fontSize:14,color:'#666',textAlign:'center',fontFamily:'DINAlternate-Bold'}}>{item.compareToPrevious === "--" ? item.compareToPrevious:item.compareToPrevious !== null ? Util.keepfomatFloat(item.compareToPrevious):"--"}</div>
                                      </div>
                                  }
                                </div>
                            }
                          </div>
                        )
                      })
                    }
                    {/* <div onClick={()=>this.goFundGk("资产/行业分布")} style={{display:'flex',justifyContent:'center',alignItems:'center',marginTop:15}}>
                      <div style={{...styles.font12999}}>查看更多</div>
                      <img src={require('../../../imgs/icon_arraw_right_gray.png')} style={{height:10,width:10}} alt='' />
                    </div> */}
                  </div>
                :null
              }
            </div>
            <div style={{height:10,background:'#F5F6F7'}}></div>
            <div style={{paddingLeft:20,paddingRight:20,background:'#fff'}}>
              {
                latestPublicFundAnnouncement ?
                  <div onClick={()=>this.OpenApp()} style={{display:'flex',height:52,justifyContent:'space-between',alignItems:'center'}}>
                    <div style={styles.font16333}>基金公告</div>
                    <div style={{display:'flex',alignItems:'center'}}>
                      <div style={{fontSize:14,color:'#999'}}>{latestPublicFundAnnouncement.publishDate === null? "暂无公告记录":latestPublicFundAnnouncement.publishDate+"更新"}</div>
                      {
                        latestPublicFundAnnouncement.publishDate === null? 
                          null
                        :
                        <img src={require('../../../imgs/icon_arraw_right_gray.png')} style={{height:10,width:10}} alt='' />
                      }
                    </div>
                  </div>
                :
                  null
              }
              <div style={{height:1,background:'#EFF0F4'}}></div>
              {
                dataInfo ? 
                  dataInfo.fundtype === "货币型" ?
                    null
                  :
                    // <div onClick = {latestDividend ? latestDividend  ? ()=>{this.goFundGk("分红记录")}:()=>{}:()=>{}} style={{display:'flex',height:52,justifyContent:'space-between',alignItems:'center'}}>
                    <div onClick={()=>this.OpenApp()}  style={{display:'flex',height:52,alignItems:'center',justifyContent:'space-between'}}>
                      <div style={styles.font16333}>分红记录</div>
                      {
                        latestDividend  ?
                          <div style={{fontSize:14,color:'#999'}}>
                            每份分红
                            <span style={{fontFamily:'DINAlternate-Bold'}}>
                              {Util.Retainfourdecimalplaces(latestDividend.dividendPerShare)|| "--"}（{latestDividend ? this.dateformat(latestDividend.equityRegistrationDate):"--"}）
                            </span>
                            <img src={require('../../../imgs/icon_arraw_right_gray.png')} style={{height:10,width:10}} alt='' />
                          </div>
                      :
                        <div style={{display:'flex',alignItems:"center"}}>
                          <div style={{fontSize:14,color:'#999'}}>暂无分红记录</div>
                        </div>
                      }
                    </div>
                :
                  null
              }
              <div style={{height:1,background:'#EFF0F4'}}></div>
              <div onClick={()=>this.OpenApp()} style={{display:'flex',height:52,justifyContent:'space-between',alignItems:'center'}} >
                <div style={styles.font16333}>产品资料概要</div>
                <div  style={{fontSize:14,color:'#999'}}>
                  <img src={require('../../../imgs/icon_arraw_right_gray.png')} style={{height:10,width:10}} alt='' />
                </div>
              </div>
            </div>

            <div style={{height:10,background:'#F5F6F7'}}></div>
            {
              dataInfo ? 
                dataInfo.fundtype === "货币型" ?
                  null
                :
                  <div>
                  {
                    acRelationFundCode ? 
                      <div onClick={()=>this.OpenApp()} style={{fontSize:14,color:'#F92C3D',background:'#fff',height:44,display:'flex',justifyContent:'center',alignItems:'center'}}>
                        <span style={{color:'#F92C3D'}}  target='_blank' >查看{relationFundName}</span>
                      </div>
                    :
                      null
                  } 
                  </div>
              :
                null
            }
            <div onClick={()=>this.OpenApp()} style={{padding:20,backgroundColor:'rgb(245, 246, 247)'}}>
              <div style={{borderRadius:10,marginBottom:20,background:'#fff',height:44,paddingLeft:15,paddingRight:15,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                <div style={{display:'flex',alignItems:'center'}}>
                  <img src={require('../../../imgs/icon_kefu.png')} style={{height:20,width:20,marginRight:10}} alt='' />
                  <div style={{fontSize:12,color:'#666'}}>
                    对产品有疑问，
                    <span style={{color:'#F92C3D'}}>咨询在线客服</span>
                  </div>
                </div>
                <img src={require('../../../imgs/icon_arraw_right_gray.png')} style={{height:10,width:10}} alt='' />
              </div>
              <div style={{width:'100%',textAlign:'center',fontSize:12,color:'#999',marginBottom:5}}>- 民生银行全程保证资金交易安全 -</div>
              <div style={{marginBottom:23,fontSize:12,color:'#999',width:'100%',textAlign:'center'}}>数据来源：Wind、银河证券、基金管理人</div>
              <div style={{width:'100%',textAlign:'center',fontSize:12,color:'#999',lineHeight:'17px'}}>基金的过往业绩不预示其未来表现，相关数据仅供参考，不构成投资建议。投资人请详阅基金合同和基金招募说明书，并自行承担投资基金的风险。</div>
            </div>
          </div>
        </div>
        {/* 申购按钮 */}
        <div onClick = {this.OpenApp} style={{background:'#fff',width:'100%'}}>
          {
            dataInfo ? 
            dataInfo.fundtype === "货币型"?
              null
            :
              <div style={{height:32,borderBottom:'1px solid #EFF0F4',boxShadow:'0px -1px 0px 1px #EFF0F4',display:'flex',fontSize:12,alignItems:'center',justifyContent:'center'}}>
                <div style={{marginRight:10,color:'#666'}}>
                  <span>购买费率 &nbsp;</span>
                  {
                    dataSource && dataSource.maxBuyRate&& (dataSource.maxBuyRate.conditionRate === "0.00%")?
                      <span>0.00%</span>
                    :
                      <span>
                         <span style={{textDecorationLine:"line-through"}} >{dataSource?dataSource.maxBuyRate ? dataSource.maxBuyRate.conditionRate:"":''}</span>
                         <span>{dataSource?dataSource.discountFeeRate ? (dataSource.discountFeeRate)  + "  起":"--":''}</span>
                      </span>
                  }
                </div>
                <img src={require('../../../imgs/icon_arraw_right_gray.png')} style={{height:10,width:10}} alt='' />
              </div>
            :null
          }
          <div style={{display:'flex',alignItems:'center',paddingRight:20,paddingBottom:5,paddingTop:10,paddingLeft:20}}>
            <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',paddingTop:10}}>
              {
                is_optional === '0'?
                  <img src={require('../../../imgs/icon_add_self.png')} style={{height:20}} alt='' />
                :
                  <img src={require('../../../imgs/subscribe_icon_del_self.png')} style={{height:20}} alt='' />
              }
              <div style={{fontSize:18,WebkitTransform:'scale(0.5)'}}>{ is_optional === '0'? '加自选':'取消自选'}</div>
            </div>

            {
              this.state.dataSource ?
                this.state.dataSource.fundCanDT ?
                  <div style={{display:'flex',alignItems:'center',fontSize:16,flex:1}}>
                    <div   style={{display:'flex',justifyContent:'center',alignItems:'center',height:44,flex:1,background:'#FEE9EB',color:'#F92C3D',borderTopLeftRadius:22,borderBottomLeftRadius:22}}>
                      定投
                    </div>
                    {
                      this.state.dataSource ? 
                        this.state.dataSource.businessType === "T022" ||  this.state.dataSource.businessType === "T020"? 
                          <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:44,flex:1,background:'#F92C3D',color:'#fff',borderTopRightRadius:22,borderBottomRightRadius:22}}>
                            申购
                          </div>
                        :
                          <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:44,flex:1,background:'#afb0b2',color:'#fff',borderTopRightRadius:22,borderBottomRightRadius:22}}>
                            申购
                          </div>
                      :
                        <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:44,flex:1,background:'#afb0b2',color:'#fff',borderTopRightRadius:22,borderBottomRightRadius:22}}>
                          申购
                        </div>
                    }
                  </div>
                :
                  <div style={{flex:1,height: 44,display:'flex',alignItems:'center',borderRadius: 22,marginLeft:10,fontSize:16}}>
                    {
                      this.state.dataSource ? 
                        this.state.dataSource.businessType === "T022" ||  this.state.dataSource.businessType === "T020"? 
                          <div style={{ display:'flex',flex:1, height: 44,backgroundColor: '#F92C3D', borderRadius:22,alignItems: 'center', justifyContent: 'center' ,color:'#fff'}}>
                            申购
                          </div>
                        :
                          <div style={{ flex:1,display:'flex',justifyContent:'center',alignItems:'center',borderRadius: 22,height:44,background:'#afb0b2',color:'#fff'}}>
                            申购
                          </div>
                      :
                        <div style={{ flex:1,display:'flex',justifyContent:'center',alignItems:'center',borderRadius: 22,height:44,background:'#afb0b2',color:'#fff'}}>
                          申购
                        </div>
                    }
                  </div>
              :
                null
            }
          </div>
        </div>
        {
          !this.state.dataInfo?
            <div style={{background:'#fff',position:'absolute',width:'100%',height:'100%',zIndex:9999}}></div>
          : null
        }
        {
          this.state.tipIntroduce ?
            <FundAnalysisTips onOK = {()=>this.setState({tipIntroduce: false}) } />
          :
            null
        }
        {
          this.state.investflag?
          <div style = {styles.container2}>
          <div style = {styles.modalView}>
            <div style={{paddingLeft:25,paddingRight:25,paddingTop:24}}>
              <div style = {{fontSize:14,lineHeight:'20px',color:"#333333",fontWeight:"500",textAlign:'center'}}></div>
            </div>
            <div style={{paddingLeft:25,paddingRight:25,paddingTop:12}}>
              <div style = {{fontSize:14,lineHeight:'20px',color:"#333333"}}>如果出现各资产总和占净值比例超过100%的现象，一般是由于基金在运作过程中存在负债，如存在应付账款或债券质押杠杆交易等情况。</div>
            </div>
            <div onClick = {()=>{this.setState({investflag:false})}} style={{...styles.footHeight,width: 273,height:43,borderTop:'1px solid #EBEBEB',marginTop:20}}>
              <div style = {{fontSize: 14,color:'#333',lineHeight:'20px',fontWeight:"500"}}>知道了</div>
            </div>
          </div>
        </div>          :
          null
        }
        { this.state.selectOther?
          <SelectOtherTransRecord title='取消'  
          listContent={[
            {title:'近3年',callback:()=>{this.selectTabFun("近3年")}},
            {title:'近5年',callback:()=>{this.selectTabFun("近5年")}},
            {title:'今年以来',callback:()=>{this.selectTabFun("今年以来")}},
            {title:'成立以来'+"("+chengli+")",callback:()=>{this.selectTabFun('成立以来')}},
            ]}
          cancelCallback={()=>{this.setState({selectOther:false})}}
          symbolvalue={this.state.selectTab}
          chengli={chengli}
          />:null
        }
        { this.state.Basicfalg?
          <SelectOtherzhishu title='取消'  
          listContent={productTypeListContent}
          cancelCallback={()=>{this.setState({Basicfalg:false})}}
          symbolcode= {this.state.symbolcode}
          />
          :null
        }
        {this.state.tebflag ?
          <div style={{zIndex:1,width:'100%',height:45,display:"flex",alignItems:"center",position:"absolute",top:50,background:`url(${require('../../../imgs/subscribe_bg.png')}) repeat-x`,backgroundSize:'cover'}}>
            {
              this.state.tabtextList.map((item,index)=>{
                let opacity 
                if(item === this.state.tabtext){
                  opacity = 1
                }else{
                  opacity = 0
                }
                return(
                  <div key={index+''} onClick={()=>this.handleLocation(index)} style={{flex:1,display:'flex',flexDirection:'column',alignItems:"center",justifyContent:"center"}}>
                    <div style={{color:"#FFFFFF",fontSize:14,marginBottom:5}}>
                      {item}
                    </div>
                    <div style={{width:28,height:3,backgroundColor:"#fff",opacity:opacity}}></div>
                  </div>
                )
              })
            }
          </div>
          :
          null
        }
      </div>
    )
  }
}

class HistoryList extends Component{
  constructor(props){
    super(props)
    this.state = {
      key : '1'
    }
  }
  handleClick(key){
    this.setState({key})
  }
  goToDetailedPages=(data,historyType)=>{
    // console.log( '是否展示',data.homogeneousAverageFlag);
      hashHistory.push({
        pathname: '/HistoryAchievement',
        state:{
          fundCode:data.fundcode,//'003003',//002460货币  002460非货币  data.fundcode
          dispatch:this.props.dispatch,
          fundType:data.fundtype,//'货币型',//0 货币  1 非货币 data.fundtype
          fundTypeTitle:data.fundname, //data.fundname
          historyType,
          homogeneousAverageFlag:this.props.dataSource.homogeneousAverageFlag
        }
      });
  }

  //涨跌幅颜色
  Coloroffluctuationrange=(val)=>{
    val =Number(val)
    let valColor = "#999999";
    if(val == 0) {
      valColor = "#999999";
    }else if(val < 0) {
      valColor = "#1DA96B";
    }else if(val > 0) {
      valColor = "#FA063A";
    }else {
      valColor = "#999999";
    }
    return valColor
  }
  render(){
    let {historyList,Netperformance,dataSource,dataInfo,AccumulatedNet} = this.props
    return (
      <Tabs 
        defaultActiveKey="1"
        swipeable={false}
        type="card" 
        animated={true}
        activeKey={this.state.key}
        renderTabBar={() => {
          return(
            <div style={{display:'flex',marginBottom:15}}>
              {
                historyList.map((item,index)=>{
                  let fontColorName = index+1+'' === this.state.key ? "b1" : "b2"
                  let lineColor = index+1+'' === this.state.key ? "activeLine" : "notActiveLine"
                  return(
                    <div key={index+1+''} onClick={()=>this.handleClick(index+1+'')} style={{display:'flex',lineHeight:'16px',flexDirection:'column',justifyContent:'center',alignItems:'center',marginRight:25}}>
                      <div style={{...styles[fontColorName],marginBottom:8}}>{item}</div>
                      <div style={{...styles[lineColor],height:3,width:28,borderRadius:2}}></div>
                    </div>
                  )
                })
              }
            </div> 
          )
        }}
      >
        {
          Netperformance?
            <TabPane tab="" key='1'>
              <div  style={{ display:'flex',justifyContent:'space-around',width:'100%',flex:1,marginBottom:20}}>
                  <div>
                    <div style={{...styles.font12999,height:16,flex:1,textAlign:'center',marginBottom:15}}>时间区间</div>
                    <div style={{height:16,fontSize:14,marginBottom:20,color:'#666',flex:1,textAlign:'center'}}>今年以来</div>
                    <div style={{height:16,fontSize:14,marginBottom:20,color:'#666',flex:1,textAlign:'center'}}>近一月</div>
                    <div style={{height:16,fontSize:14,marginBottom:20,color:'#666',flex:1,textAlign:'center'}}>近一年</div>
                    <div style={{height:16,fontSize:14,color:'#666',flex:1,textAlign:'center'}}>近三年</div>
                  </div>
                  <div>
                    <div style={{...styles.font12999,height:16,flex:1,textAlign:'center',marginBottom:15}}>涨跌幅</div>
                    <div style={{height:16,fontSize:14,marginBottom:20,fontFamily:'DINAlternate-Bold',flex:1,textAlign:'center',color:Netperformance.yearnavchgrate ? this.Coloroffluctuationrange(Netperformance.yearnavchgrate):"#999999"}}>{Util.keepfomatFloat(Netperformance.yearnavchgrate)}</div>
                    <div style={{height:16,fontSize:14,marginBottom:20,fontFamily:'DINAlternate-Bold',color:Netperformance.m1 ? this.Coloroffluctuationrange(Netperformance.m1):"#999999",flex:1,textAlign:'center'}}>{Util.keepfomatFloat(Netperformance.m1)}</div>
                    <div style={{height:16,fontSize:14,marginBottom:20,fontFamily:'DINAlternate-Bold',color:Netperformance.y1 ? this.Coloroffluctuationrange(Netperformance.y1):"#999999",flex:1,textAlign:'center'}}>{Util.keepfomatFloat(Netperformance.y1)}</div>
                    <div style={{height:16,fontSize:14,fontFamily:'DINAlternate-Bold',color:Netperformance.y3 ? this.Coloroffluctuationrange(Netperformance.y3):"#999999",flex:1,textAlign:'center'}}>{Util.keepfomatFloat(Netperformance.y3)}</div>
                  </div>
                  {
                    dataSource ? 
                      dataSource.homogeneousAverageFlag ?
                      <div>
                        <div style={{...styles.font12999,height:16,flex:1,textAlign:'center',marginBottom:15}}>同类平均</div>
                        <div style={{height:16,fontSize:14,marginBottom:20,fontFamily:'DINAlternate-Bold',color:Netperformance.sfReturnThisYear ? this.Coloroffluctuationrange(Netperformance.sfReturnThisYear):"#999999",flex:1,textAlign:'center'}}>{Util.keepfomatFloat(Netperformance.sfReturnThisYear)}</div>
                        <div style={{height:16,fontSize:14,marginBottom:20,fontFamily:'DINAlternate-Bold',color:Netperformance.sfReturnRecentMonth ? this.Coloroffluctuationrange(Netperformance.sfReturnRecentMonth):"#999999",flex:1,textAlign:'center'}}>{Util.keepfomatFloat(Netperformance.sfReturnRecentMonth)}</div>
                        <div style={{height:16,fontSize:14,marginBottom:20,fontFamily:'DINAlternate-Bold',color:Netperformance.sfReturnRecentYear ? this.Coloroffluctuationrange(Netperformance.sfReturnRecentYear):"#999999",flex:1,textAlign:'center'}}>{Util.keepfomatFloat(Netperformance.sfReturnRecentYear)}</div>
                        <div style={{height:16,fontSize:14,fontFamily:'DINAlternate-Bold',color:Netperformance.sfReturnRecentThreeYear ? this.Coloroffluctuationrange(Netperformance.sfReturnRecentThreeYear):"#999999",flex:1,textAlign:'center'}}>{Util.keepfomatFloat(Netperformance.sfReturnRecentThreeYear)}</div>
                      </div>
                      :
                        null
                    :
                      null
                  }
                </div> 
                {/* <div onClick={()=>{this.goToDetailedPages(dataInfo,'历史业绩')}} style={{...styles.font12999,display:'flex',alignItems:'center',justifyContent:'center',marginBottom:20}}>
                  查看更多
                  <img src={require('../../../imgs/icon_arraw_right_gray.png')} style={{height:10,width:10}} alt='' />  
                </div> */}
            </TabPane>
          :
            null
        }
        {
          dataInfo ? 
            dataInfo.fundtype === "货币型"?
              <TabPane tab="" key='2'>
                <div  style={{ width: '100%',flex:1}}>
                  <div style={{dispaly:'flex',height:16,alignItems:"center",marginBottom:15,display:'flex'}}>
                    <div style={{...styles.font12999,flex:1,textAlign:'center'}}>日期</div>
                    <div style={{...styles.font12999,flex:1,textAlign:'center'}}>七日年化</div>
                    <div style={{...styles.font12999,flex:1,textAlign:'center'}}>万份收益</div>
                  </div>
                  {
                    AccumulatedNet ? 
                      AccumulatedNet.map((item,index)=>{
                        return(
                          <div key={index} style={{display:'flex',height:16,alignItems:"center",marginBottom:20}}>
                            <div style={{flex:1,textAlign:'center',color:"#666666",fontSize:14,fontFamily:'DINAlternate-Bold'}}>{item.publish_date||"--"}</div>
                            <div style={{flex:1,textAlign:'center',color:this.Coloroffluctuationrange(item.value_2_2),fontSize:14,fontFamily:'DINAlternate-Bold'}}>{(Util.Retainfourdecimalplaces(item.value_2_2)+"%")||"--"}</div>
                            <div style={{flex:1,textAlign:'center',color:"#666",fontSize:14,fontFamily:'DINAlternate-Bold'}}>{Util.Retainfourdecimalplaces(item.value_2_1)||"--"}</div>
                          </div>
                      )})
                    :
                      <div style={{display:'flex',height:16,textAlign:"center",marginBottom:20}}>
                        暂无数据
                      </div>
                  }
                  {/* {
                    AccumulatedNet? 
                      <div style={{display:'flex',justifyContent:'center',alignItems:'center',marginBottom:20}} onClick={()=> {this.goToDetailedPages(dataInfo,'历史收益')}}>
                        <div style={{color:"#999999",fontSize:12}} >查看更多</div>
                        <img style={{width:10,height:10}} src={require('../../../imgs/icon_arraw_right_gray.png')}/>
                      </div>
                    :
                      null
                  } */}
                </div> 
              </TabPane>
            :
              <TabPane tab="" key='2'>
                <div  style={{ width:'100%',flex:1}}>
                  <div style={{display:'flex',height:16,alignContent:"center",marginBottom:15}}>
                    <div style={{...styles.font12999,flex:1,textAlign:'center',marginBottom:15}}>日期</div>
                    <div style={{...styles.font12999,flex:1,textAlign:'center',marginBottom:15}}>单位净值</div>
                    <div style={{...styles.font12999,flex:1,textAlign:'center',marginBottom:15}}>累计净值</div>
                    <div style={{...styles.font12999,flex:1,textAlign:'center',marginBottom:15}}>日涨跌幅</div>
                  </div>
                  {
                    AccumulatedNet? 
                      AccumulatedNet.map((item,index)=>{
                        return(
                          <div key={index} style={{display:'flex',height:16,alignContent:"center",marginBottom:20}}>
                            <div style={{flex:1,textAlign:'center',color:"#666666",fontSize:14,fontFamily:'DINAlternate-Bold'}}>{item.publish_date||"--"}</div>
                            <div style={{flex:1,textAlign:'center',color:"#666666",fontSize:14,fontFamily:'DINAlternate-Bold'}}>{item.value_134||"--"}</div>
                            <div style={{flex:1,textAlign:'center',color:"#666666",fontSize:14,fontFamily:'DINAlternate-Bold'}}>{item.value_134_2||"--"}</div>
                            <div style={{flex:1,textAlign:'center',color:this.Coloroffluctuationrange(item.value_zdf),fontSize:14,fontFamily:'DINAlternate-Bold'}}>{Util.keepfomatFloat(item.value_zdf)}</div>
                          </div>
                        )})
                    :
                      <div  style={{display:'flex',height:16,textAlign:"center",marginBottom:20}}>
                        暂无数据
                      </div>
                  }
                  
                  {/* {
                    AccumulatedNet? 
                      <div style={{display:'flex',justifyContent:'center',alignItems:'center',marginBottom:20}}  onClick={()=> {this.goToDetailedPages(dataInfo,'历史净值')}}>
                        <div style={{color:"#999999",fontSize:12}} >查看更多</div>
                        <img style={{width:10,height:10}} src={require('../../../imgs/icon_arraw_right_gray.png')}/>
                      </div>
                    :
                      null
                    } */}
                </div> 
              </TabPane>
          :
            null
        }
      </Tabs>
    )
  }
}

export class EchartsBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lodingflag: false,
      newNev: null,
      newData: null,
      newNevs: null,
      newDatas: null,
      checkykDate: null,
      checkykVal: null,
      newNav: null,
      incomeList: null,
      allIncome: null,
      Lineval:null,
      chenck:false,
      chencked:false,
      showdataArr:null,
      _value:[]
    }
    this.myChart = null
  }
  componentDidMount = () => {
    this.props.onRef(this)
    if(document.querySelector(`#PublicLine`)){
      if (window.isLess47) {
        this.myChart = echarts.init(document.querySelector(`#PublicLine`));
      } else {
        this.myChart = echarts.init(document.querySelector(`#PublicLine`), null, { renderer: "svg" });
      }
      this.myChart.clear();
      this.myChart.resize();
    }
  }
  //业绩走势
  showOption = (val) => {
    let { _profitNav, _profitData,_dotnav,_maxDrawDownValue } = val;
    console.log(_profitNav)
    let buyAndSaleDateArr = [];
    let _tabVal = this.props._tabVal;

    let newbuyDateList = this.props._thisObj.state.buyDateList ? this.props._thisObj.state.buyDateList : []
    let newredeemDateList = this.props._thisObj.state.redeemDateList ? this.props._thisObj.state.redeemDateList : []
    let dividendDateList = this.props._thisObj.state.dividDateList ? this.props._thisObj.state.dividDateList : []
    let newbuynameArr = []
    let redeemnameArr = []
    let dividendnameArr = []

    let seriesArr = [];
    let _valueAll = [];
    let _LineAll = [];
    let _maxDrawDownAll = [];
    let newNev = _profitNav.length > 0 && Util.returnEmptyAlone (_profitNav[_profitNav.length - 1].value) && _profitNav[_profitNav.length - 1].value !== '--' ? _profitNav[_profitNav.length - 1].value : '--';
    let newData = _profitData.length > 0 && Util.returnEmptyAlone (_profitData[_profitData.length - 1]) && _profitData[_profitData.length - 1] !== '--'? _profitData[_profitData.length - 1] : '--';
    let _value = val._profitNav;
    let _name = val._profitData;
    let sum=val._profitData.length
    let _name1 = [_name[0],_name[sum-1]];
    let dotvalue = _dotnav;
    this.setState({showdataArr:val})
    for (let i = 0; i < _profitNav.length; i++) {
      _valueAll.push({
        value:_profitNav[i].allIncome,
        deadLine:_profitNav[i].deadLine,
      })
    }
    for (let i = 0; i < _profitNav.length; i++) {
      _LineAll.push({
        value:_profitNav[i].Lineval,
        deadLine:_profitNav[i].deadLine,
      })
    }
    for (let i = 0; i < _profitNav.length; i++) {
      _maxDrawDownAll.push({
        value:_profitNav[i].maxDrawDown,
        deadLine:_profitNav[i].deadLine,
      })
    }
    //转入打点
    for (let i = 0; i < newbuyDateList.length; i++) {
      let indexname = _name.indexOf(newbuyDateList[i]);
      if (indexname !== -1) {
        let salenameVal = dotvalue[indexname]
        newbuynameArr.push([indexname, salenameVal])
      }
    }
      for (let i = 0; i < newbuynameArr.length; i++) {
        buyAndSaleDateArr.push(
          {
            coord: newbuynameArr[i],
            symbolSize: 6,
            symbol: 'circle',
            itemStyle: {
              normal: {
                color: '#407BE7',
                borderWidth: 1,
                borderColor: '#FFFFFF'
              }
            }
          })
        if (i == newbuynameArr.length-1) {
          buyAndSaleDateArr.push({
            coord: newbuynameArr[i],
            symbolSize: 25,
            symbolOffset: [0, -15],
            symbolKeepAspect: true,
            symbol: 'image://data:data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAVCAYAAABR915hAAAAAXNSR0IArs4c6QAAAstJREFUSEvFlttLVFEUh79zzjijc/GKl6BQCimtTIsyzEgtMLMkxKSHJHwoIoqCoP6CHgoKo3ryIUiIIBRTNAoM85JSSCmGhYVU+qCW13Fm1Jlz4owedcYZbQpxP6699vrWb6+1L4KiKHrgNlACRLK2YwSoAK4LiqKUfex1XKl4OcnElLym2FCTSEmuhdTE4Hsq+Pe1B8ORaw3VFKnwO5eiR1Swcu7W4Joq9Q5efiMWn+Ck+CBMIaLfZIZGXfwYdHrMH003YnPINHU6VhXhF5yaaMBiXAQLgCCArEBCnI5f4y5etNs8AKIAFwvD3PZvA7Mrwv2C1VXpyQaSEwzUtlqJCpNISjBQ3WSlNN9C3VsbqmrvERUqcuFkGDcfj/4bWFU1aZfRiQKZKcF0980sgCUJXMuZbtDOzXrO5oVSXjPOl5/+VftVvCFK4niGiZFJmcpGKylb9GyK0VHX5rm93rJKj1lo7nKQu8/Iw6pxv6p9gtVaGoLUqkJshMTgqIvs3SFY7TLve6YXgs06FVxLjn1cpMSpbDP3K8c5XxBKfbuN/iHPBtQW+wTHREicPmzxyHZbvJ7P32c8bA0dNj71zdnUZC8XhVPVaKV/2OlO+EyuhbtPx1B86F6xuTT/rLQQ97bXt03R3GVn1oeIoiwzsy6F581TC5j8DBNBElQvsa2oWJvcGK0jb78RpwxPXk2wZ2swB3eF8K7HwZsPdvfRkkQozjETbBB5VDexTJu65QPDzmW94VOxGuxqcThTdpmGDju9/Yvdqc4d2Wtke4KesmdjpCUaUEvjfaa1DEQRCg+Z6fw6Te+SLve71WrNFF/FmY+oBpT/4z3RwOv2SKzbsxjwR6CmxUpt61wHnzhgoiDTvOrDMO+w+BH42xWan6Io0cDrmhbrDtVWkGnuBnIEQRgOJNbcFRXg0ODzywKGui+dAJkL7vNwAlWqBfgDpUlb6dF6Xa8AAAAASUVORK5CYII='
          })
        }
      }
      //转出打点
      for (let i = 0; i < newredeemDateList.length; i++) {
        let indexname = _name.indexOf(newredeemDateList[i]);
        if (indexname !== -1) {
          let salenameVal = dotvalue[indexname]
          redeemnameArr.push([indexname, salenameVal])
        }
      }
      for (let i = 0; i < redeemnameArr.length; i++) {
        buyAndSaleDateArr.push({
          coord: redeemnameArr[i],
          symbolSize: 6,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: '#FF8026',
              borderWidth: 1,
              borderColor: '#FFFFFF'
            }
          }
        })
        if (i == redeemnameArr.length-1) {
          buyAndSaleDateArr.push({
            coord: redeemnameArr[i],
            symbolSize: 25,
            symbolOffset: [0, -15],
            symbolKeepAspect: true,
            symbol: 'image://data:data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAVCAYAAABR915hAAAAAXNSR0IArs4c6QAAAn5JREFUSEvFll1Ik1EYgJ/PWaSF0VIqCtKMtBgURX8uSdcKoYIK8i4KMaNQlLIuihBvI2qiNxlEUaAsW13sqvInQrFpKSFkUaKgV/4UNW3+zC9OZ+tM2QdbOHzhwHnP+573+d4fOJ+m6/pS4BZwBjATWxkDHgPXNF3XHfS+LsVdAeMjscUuT4ZjlZBprxLgUW5bzTGHBlMS8PLWMQHWqcyIbabzo1d8JjxYi4MVKcr9tAOelindOwK6X+pLEuSaEO0Dip5D7Um5TzTD9G+5QsUQnLAS7OXKdYsNvjQpvfGuAm2ywsbd0OyQ9gsv4N4Juc8tg4EO6GuNEJxhA5MY9oDklkJzldJ9P6GvTeoLCrYchcRV4J+WK84ESWvhxxAsS4LUPVB/SYG3HoF3j6SeXwPOYrnfexY+vYwiY80E67ZBVgGM9kNHHeRdh4Yy2JkPs37ofiaDp2yGfedUNTIPQ+8rpbc/hOGvEZZ6ww7Ivii/drAbpsbBfhVcV2B1GniHYdIrg6Vnw7e3KnBoj8PZxVnY4RITnX5AltdyHHrckJwG67dDV4MC9HtgxgfnXXD/lDF4vt0QHBcP+wtUIFM8WAvB8wR8gSyFtbMOJn8tIDiIFH1Ot0JWIQx2yV5OfIcPThj6qD6syAVtD5R+6DI03lG6mJPakIoYZiwMeTdgTSYMeKCzXvZUiDlV9t4/Be6b8kyA3zvnDk+otis/CrAo9+yMcbBQu5gFMeVGEs4eGK5FeyQW7VmM/kegpRre1MjiHiyGnBLjUs+1qB+BSG8E/XRdF89WEy3Vlr9nOSU9gE3TtMAERhZRi8xtrtc/uDyOGiou/RdYXAzAiTbTYAp/APioK+lF/NQbAAAAAElFTkSuQmCC'
          },)
        }
      }
      //分红打点
      for (let i = 0; i < dividendDateList.length; i++) {
        let indexname = _name.indexOf(dividendDateList[i]);
        if (indexname !== -1) {
          let salenameVal = dotvalue[indexname]
          dividendnameArr.push([indexname, salenameVal])
        }
      }
      for (let i = 0; i < dividendnameArr.length; i++) {
        buyAndSaleDateArr.push({
          coord: dividendnameArr[i],
          symbolSize: 6,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: '#F8515C',
              borderWidth: 1,
              borderColor: '#FFFFFF'
            }
          }
        })
        if (i == 0) {
          buyAndSaleDateArr.push({
            coord: dividendnameArr[i],
            symbolSize: 25,
            symbolOffset: [0, -15],
            symbolKeepAspect: true,
            symbol: 'image://data:data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAVCAYAAABR915hAAAAAXNSR0IArs4c6QAAAtlJREFUSEvFlllIVFEYx3/n3qsTLU6NTEI9mNpiJggVRWDZ8hYINQWWYNlmgS30UNlDJL7Y8lBJREUlJVFCTSBEtAcFWZpRGEkbqS0P7WTQ4D33xL3jzFRj5kyY5+nes3y/8/+Wc45QSiUCu4AiwEPfto9ADbBZKKX2yrv3NpgHq+Hzl77FDnVjrFmGPmXSPhv8IbB8rafPoSFJQ924ju3/aINVwGd7+f81l7+GHsEiLRWGe1F3GtGmT0N9+oxqfhy1Q71wIfJWPbx5i8hIjxpXrW3wPRDu7xms6xjlZZiHquHVG0jxYqwtwdxeCZYVMT5oIAnbNtG5tQIGDEBfkO+M6TNzkTduOd/ywhX4YOdVsPUI1kuKUe2vsS5cDi/Q5s1FuN3I46fCffqSRVgtTxxFItmDdf2mM5aws5zOLeXdxq97sL3rVUvg3XvkaX+0W1cUgaEjq08iRo7AWFeCPH8JbfYMzB174GtHfGCRlQnD3GjpoxCDB0eBrecvQCnU0+cgLcSE8WhZ47AetWBdvBqeH7vi0NIUL8KO88ZSzP2HobMTvMnoebmYVYciG7Jjv6IIs3IP6DqYZnyKf5GY7MEoXYlZYR9sYGe5NicPeeREcJo7iYTyLajWdnC7sS5dw7rd8O9gY8Nq5M16VNODIHhiDlp6KvJMXRCcNARt6mTUsxeol21OCEItPlcbOvrSxQiXC/PA0UgGFxdiPXqMarjfVRcuxOg0xNjRaNlZSLsC7NIDjM3rMXdVOd+qowM6voXt/LGcjLKNjgp5tg6Rk43hywdXIioQwKzYHY6jmJSDlpWJanmK9bAZMSYDfdb0qISU9Y2ohqa/g50kkTJiQBNge/EnV3ZboL3sDCnut0ui367FmB8CZq0fWXvOcaxeMB+jwNdLJxN5CPR2RWieUsoLXDNr/dlO9hb4moHZQoh3sdgSsUz+Hd71HzPUORPiATu1GVROrEpDvB9IQHHpfaA4tAAAAABJRU5ErkJggg=='
          },)
        }
      }
      console.log(_maxDrawDownAll)

          seriesArr.push(
            {
              name: _tabVal,
              type: 'line',
              smooth: false,
              symbol: 'circle',
              showSymbol: false,
              symbolSize: [5, 5],
              hoverAnimation: false,
              data: _value,
              symbolSize: 8,
              markPoint: {
                data: buyAndSaleDateArr,
                silent: true,
                label: {
                  normal: {
                    show: false
                  }
                },
              },
              itemStyle: {
                normal: {
                  color: "#BF9B79",
                  borderColor: '#FFF',
                  lineStyle: {
                    width: 2,
                    color: "#B69271",
                  },
                  areaStyle: {
                    opacity: 0.1,
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [{
                        offset: 0, color: '#B69271'
                      }, {
                        offset: 1, color: '#FBFCFD'
                      }],
                      globalCoord: false
                    }
                  }
                },
              },
              connectNulls: true,
            })
      
          seriesArr.push({
            name: _tabVal,
            type: 'line',
            smooth: false,
            symbol: 'circle',
            showSymbol: false,
            symbolSize: [5, 5],
            hoverAnimation: false,
            data: _valueAll,
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: "#BDC8D4",
                borderColor: '#FFF'
              },
            },
            connectNulls: true,
          })
          seriesArr.push({
            name: _tabVal,
            type: 'line',
            smooth: false,
            symbol: 'circle',
            showSymbol: false,
            symbolSize: [5, 5],
            hoverAnimation: false,
            data: _LineAll,
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: "#8EC7FF",
                borderColor: '#FFF'
              },
            },
            connectNulls: true,
          })
          seriesArr.push({
            name: _tabVal,
            type: 'line',
            smooth: false,
            symbol: 'circle',
            showSymbol: false,
            symbolSize: [5, 5],
            hoverAnimation: false,
            data: _maxDrawDownAll,
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: "#01D083",
                borderColor: '#FFF'
              },
            },
            connectNulls: true,
          })
    if(this.myChart){
      this.myChart.clear()
      this.myChart.resize()
      this.myChart.setOption(this.options(seriesArr, _name, _value,this.props._thisObj.state.tabVal,this))
    }
    this.setState({
      _value:_value
    })
    this.props._thisObj.setState({
      newNev: newNev, 
      newData: newData,
      allIncome: _profitNav.length > 0 && Util.returnEmptyAlone (_profitNav[_profitNav.length - 1].allIncome) && _profitNav[_profitNav.length - 1].allIncome !== '--' ? (_profitNav[_profitNav.length - 1].allIncome - 0).toFixed(2) : '--',
      Lineval:_profitNav.length > 0 && Util.returnEmptyAlone (_profitNav[_profitNav.length - 1].Lineval) && _profitNav[_profitNav.length - 1].Lineval !== '--' ? (_profitNav[_profitNav.length - 1].Lineval - 0).toFixed(2) : '--',
      lineOption1: this.options(seriesArr, _name, _value,this.props._thisObj.state.tabVal) ,
      chenck:false,
      maxDrawDownValue:_maxDrawDownValue,
    });
  }
  //单位净值 累计净值
  showOptionNav = (datas, val) => {
    let {
      oneMonthNav,
      oneMonthDate,
      threeMonthNav,
      threeMonthDate,
      sixMonthNav,
      sixMonthDate,
      oneYearNav,
      oneYearDate,
      thisyearNav,
      thisyearDate,
      ThreeYearDate,//三年
      ThreeYearNav,
      fiveYearDate,//五年
      fiveYearNav,
      totalNav,
      totalDate,
    } = datas;
    let _value = [];
    let _name = [];
    let buynameArr = []
    let salenameArr = []
    let dividnameArr=[]

    let buyDateList = this.props._thisObj.state.buyDateList ? this.props._thisObj.state.buyDateList : []
    let redeemDateList = this.props._thisObj.state.redeemDateList ? this.props._thisObj.state.redeemDateList : []
    let dividDateList = this.props._thisObj.state.dividDateList ? this.props._thisObj.state.dividDateList : []

    let buyAndSaleDateArr = [];
    let _tabVal = this.props._tabVal;
    let seriesArr = [];

    let newNev = totalNav.length > 0 ? totalNav[totalNav.length - 1] : '--';
    let newData = totalDate.length > 0 ? totalDate[totalDate.length - 1] : '--';
    this.props._thisObj.setState({ newNevs: newNev, newDatas: newData })
    if (val == "近1月") {
      _value = oneMonthNav;
      _name = oneMonthDate;
    } else if (val == "近3月") {
      _value = threeMonthNav;
      _name = threeMonthDate;
    } else if (val == "近6月") {
      _value = sixMonthNav;
      _name = sixMonthDate;
    } else if (val == "近1年") {
      _value = oneYearNav;
      _name = oneYearDate;
    } else if (val == "今年以来") {
      _value = thisyearNav;
      _name = thisyearDate;
    } else if (val == "近3年") {
      _value = ThreeYearNav;
      _name = ThreeYearDate;
    } else if (val == "近5年") {
      _value = fiveYearNav;
      _name = fiveYearDate;
    } else if (val == "成立以来") {
      _value = totalNav;
      _name = totalDate;
    }
    this.setState({
      _value:_value
    })
    for (let i = 0; i < buyDateList.length; i++) {
      let indexBuyname = _name.indexOf(buyDateList[i]);
      if (indexBuyname !== -1) {
        let buynameVal = _value[indexBuyname]
        buynameArr.push([indexBuyname, buynameVal])
      }
    }
    for (let i = 0; i < buynameArr.length; i++) {
      buyAndSaleDateArr.push(
        {
          coord: buynameArr[i],
          symbolSize: 6,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: '#407BE7',
              borderWidth: 1,
              borderColor: '#FFFFFF'
            }
          }
        })
      if (i == 0) {
        buyAndSaleDateArr.push({
          coord: buynameArr[i],
          symbolSize: 25,
          symbolOffset: [0, -15],
          symbolKeepAspect: true,
          symbol: 'image://data:data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAVCAYAAABR915hAAAAAXNSR0IArs4c6QAAAstJREFUSEvFlttLVFEUh79zzjijc/GKl6BQCimtTIsyzEgtMLMkxKSHJHwoIoqCoP6CHgoKo3ryIUiIIBRTNAoM85JSSCmGhYVU+qCW13Fm1Jlz4owedcYZbQpxP6699vrWb6+1L4KiKHrgNlACRLK2YwSoAK4LiqKUfex1XKl4OcnElLym2FCTSEmuhdTE4Hsq+Pe1B8ORaw3VFKnwO5eiR1Swcu7W4Joq9Q5efiMWn+Ck+CBMIaLfZIZGXfwYdHrMH003YnPINHU6VhXhF5yaaMBiXAQLgCCArEBCnI5f4y5etNs8AKIAFwvD3PZvA7Mrwv2C1VXpyQaSEwzUtlqJCpNISjBQ3WSlNN9C3VsbqmrvERUqcuFkGDcfj/4bWFU1aZfRiQKZKcF0980sgCUJXMuZbtDOzXrO5oVSXjPOl5/+VftVvCFK4niGiZFJmcpGKylb9GyK0VHX5rm93rJKj1lo7nKQu8/Iw6pxv6p9gtVaGoLUqkJshMTgqIvs3SFY7TLve6YXgs06FVxLjn1cpMSpbDP3K8c5XxBKfbuN/iHPBtQW+wTHREicPmzxyHZbvJ7P32c8bA0dNj71zdnUZC8XhVPVaKV/2OlO+EyuhbtPx1B86F6xuTT/rLQQ97bXt03R3GVn1oeIoiwzsy6F581TC5j8DBNBElQvsa2oWJvcGK0jb78RpwxPXk2wZ2swB3eF8K7HwZsPdvfRkkQozjETbBB5VDexTJu65QPDzmW94VOxGuxqcThTdpmGDju9/Yvdqc4d2Wtke4KesmdjpCUaUEvjfaa1DEQRCg+Z6fw6Te+SLve71WrNFF/FmY+oBpT/4z3RwOv2SKzbsxjwR6CmxUpt61wHnzhgoiDTvOrDMO+w+BH42xWan6Io0cDrmhbrDtVWkGnuBnIEQRgOJNbcFRXg0ODzywKGui+dAJkL7vNwAlWqBfgDpUlb6dF6Xa8AAAAASUVORK5CYII='
        })
      }
    }
    for (let i = 0; i < redeemDateList.length; i++) {
      let indexname = _name.indexOf(redeemDateList[i]);
      if (indexname !== -1) {
        let salenameVal = _value[indexname]
        salenameArr.push([indexname, salenameVal])
      }
    }
    for (let i = 0; i < salenameArr.length; i++) {
      buyAndSaleDateArr.push({
        coord: salenameArr[i],
        symbolSize: 6,
        symbol: 'circle',
        itemStyle: {
          normal: {
            color: '#FF8026',
            borderWidth: 1,
            borderColor: '#FFFFFF'
          }
        }
      })
      if (i == 0) {
        buyAndSaleDateArr.push({
          coord: salenameArr[i],
          symbolSize: 25,
          symbolOffset: [0, -15],
          symbolKeepAspect: true,
          symbol: 'image://data:data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAVCAYAAABR915hAAAAAXNSR0IArs4c6QAAAn5JREFUSEvFll1Ik1EYgJ/PWaSF0VIqCtKMtBgURX8uSdcKoYIK8i4KMaNQlLIuihBvI2qiNxlEUaAsW13sqvInQrFpKSFkUaKgV/4UNW3+zC9OZ+tM2QdbOHzhwHnP+573+d4fOJ+m6/pS4BZwBjATWxkDHgPXNF3XHfS+LsVdAeMjscUuT4ZjlZBprxLgUW5bzTGHBlMS8PLWMQHWqcyIbabzo1d8JjxYi4MVKcr9tAOelindOwK6X+pLEuSaEO0Dip5D7Um5TzTD9G+5QsUQnLAS7OXKdYsNvjQpvfGuAm2ywsbd0OyQ9gsv4N4Juc8tg4EO6GuNEJxhA5MY9oDklkJzldJ9P6GvTeoLCrYchcRV4J+WK84ESWvhxxAsS4LUPVB/SYG3HoF3j6SeXwPOYrnfexY+vYwiY80E67ZBVgGM9kNHHeRdh4Yy2JkPs37ofiaDp2yGfedUNTIPQ+8rpbc/hOGvEZZ6ww7Ivii/drAbpsbBfhVcV2B1GniHYdIrg6Vnw7e3KnBoj8PZxVnY4RITnX5AltdyHHrckJwG67dDV4MC9HtgxgfnXXD/lDF4vt0QHBcP+wtUIFM8WAvB8wR8gSyFtbMOJn8tIDiIFH1Ot0JWIQx2yV5OfIcPThj6qD6syAVtD5R+6DI03lG6mJPakIoYZiwMeTdgTSYMeKCzXvZUiDlV9t4/Be6b8kyA3zvnDk+otis/CrAo9+yMcbBQu5gFMeVGEs4eGK5FeyQW7VmM/kegpRre1MjiHiyGnBLjUs+1qB+BSG8E/XRdF89WEy3Vlr9nOSU9gE3TtMAERhZRi8xtrtc/uDyOGiou/RdYXAzAiTbTYAp/APioK+lF/NQbAAAAAElFTkSuQmCC'
        },)
      }
    }
            //分红打点
      for (let i = 0; i < dividDateList.length; i++) {
        let indexname = _name.indexOf(dividDateList[i]);
        if (indexname !== -1) {
          let salenameVal = _value[indexname]
          dividnameArr.push([indexname, salenameVal])
        }
      }
      for (let i = 0; i < dividnameArr.length; i++) {
        buyAndSaleDateArr.push({
          coord: dividnameArr[i],
          symbolSize: 6,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: '#F8515C',
              borderWidth: 1,
              borderColor: '#FFFFFF'
            }
          }
        })
        if (i == 0) {
          buyAndSaleDateArr.push({
            coord: dividnameArr[i],
            symbolSize: 25,
            symbolOffset: [0, -15],
            symbolKeepAspect: true,
            symbol: 'image://data:data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAVCAYAAABR915hAAAAAXNSR0IArs4c6QAAAtlJREFUSEvFlllIVFEYx3/n3qsTLU6NTEI9mNpiJggVRWDZ8hYINQWWYNlmgS30UNlDJL7Y8lBJREUlJVFCTSBEtAcFWZpRGEkbqS0P7WTQ4D33xL3jzFRj5kyY5+nes3y/8/+Wc45QSiUCu4AiwEPfto9ADbBZKKX2yrv3NpgHq+Hzl77FDnVjrFmGPmXSPhv8IbB8rafPoSFJQ924ju3/aINVwGd7+f81l7+GHsEiLRWGe1F3GtGmT0N9+oxqfhy1Q71wIfJWPbx5i8hIjxpXrW3wPRDu7xms6xjlZZiHquHVG0jxYqwtwdxeCZYVMT5oIAnbNtG5tQIGDEBfkO+M6TNzkTduOd/ywhX4YOdVsPUI1kuKUe2vsS5cDi/Q5s1FuN3I46fCffqSRVgtTxxFItmDdf2mM5aws5zOLeXdxq97sL3rVUvg3XvkaX+0W1cUgaEjq08iRo7AWFeCPH8JbfYMzB174GtHfGCRlQnD3GjpoxCDB0eBrecvQCnU0+cgLcSE8WhZ47AetWBdvBqeH7vi0NIUL8KO88ZSzP2HobMTvMnoebmYVYciG7Jjv6IIs3IP6DqYZnyKf5GY7MEoXYlZYR9sYGe5NicPeeREcJo7iYTyLajWdnC7sS5dw7rd8O9gY8Nq5M16VNODIHhiDlp6KvJMXRCcNARt6mTUsxeol21OCEItPlcbOvrSxQiXC/PA0UgGFxdiPXqMarjfVRcuxOg0xNjRaNlZSLsC7NIDjM3rMXdVOd+qowM6voXt/LGcjLKNjgp5tg6Rk43hywdXIioQwKzYHY6jmJSDlpWJanmK9bAZMSYDfdb0qISU9Y2ohqa/g50kkTJiQBNge/EnV3ZboL3sDCnut0ui367FmB8CZq0fWXvOcaxeMB+jwNdLJxN5CPR2RWieUsoLXDNr/dlO9hb4moHZQoh3sdgSsUz+Hd71HzPUORPiATu1GVROrEpDvB9IQHHpfaA4tAAAAABJRU5ErkJggg=='
          },)
        }
      }
    seriesArr.push(
      {
        name: _tabVal,
        type: 'line',
        smooth: false,
        symbol: 'circle',
        showSymbol: false,
        symbolSize: [5, 5],
        hoverAnimation: false,
        data: _value,
        symbolSize: 8,
        markPoint: {
          data: buyAndSaleDateArr,
          silent: true,
          label: {
            normal: {
              show: false
            }
          },
        },
        itemStyle: {
          normal: {
            color: "#BF9B79",
            borderColor: '#FFF',
            lineStyle: {
              width: 2,
              color: "#B69271",
            },
            areaStyle: {
              opacity: 0.1,
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: '#B69271'
                }, {
                  offset: 1, color: '#FBFCFD'
                }],
                globalCoord: false
              }
            }
          },
        },
      })
      if(this.myChart){
        this.myChart.clear()
        this.myChart.resize()
        this.myChart.setOption(this.options(seriesArr, _name, _value,this.props._thisObj.state.tabVal,this))
      }
      this.props._thisObj.setState({ 
        lineOption: this.options(seriesArr, _name, _value,this.props._thisObj.state.tabVal) ,
        chencked:false,
      })
  }
  options = (seriesArr, _name, _value,_tabVal,_this) => {
    if(_tabVal == "业绩走势"||_tabVal == "七日年化"){
      let optionA = {
        calculable: true,
        series: seriesArr,
        grid: {
          y: '10%',
          left: 70,
          bottom: 50,
          top: 60, //75
        },
        tooltip: {
          show: true,
          position: [15, 0],
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#F92C3D',
              width: 1,
              type: 'dashed',
            },
            label:{
              margin:20,
              show:true,
              backgroundColor:'#F92C3D'
            }
          },
          backgroundColor: "rgba(246, 247, 250, 1)",
          extraCssText: 'box-shadow: 0 0 0 rgba(0, 0, 0, 0.3)',
          textStyle: { fontSize: 12 },
          formatter: function(params){
            if (_this.props._tabVal == '业绩走势') {
              _this.setState({
                newNev: Util.returnEmptyAlone(params[0].data.value) === false ? _this.state.newNev : params[0].data.value,//本基金
                newData: Util.returnEmptyAlone(params[0].deadLine) === false ? _this.state.newData : params[0].deadLine,//日期
                allIncome: Util.returnEmptyAlone(params[0].data.allIncome) === false ? _this.state.allIncome : params[0].data.allIncome,  //业绩基准
                Lineval: Util.returnEmptyAlone(params[0].data.Lineval) === false ? _this.state.Lineval : params[0].data.Lineval,  //指数
              })
              _this.props._thisObj.setState({
                chenck:Util.returnEmptyAlone(params[0].data.value) === false ? false : true,
                chencked:false,
              });
            } else {
              _this.setState({
                newNevs: Util.returnEmptyAlone(params[0].value) === false ? _this.state.newNev : params[0].value,//净值
                newDatas: Util.returnEmptyAlone(params[0].name) === false ? _this.state.newData : params[0].name,//日期
              })
              _this.props._thisObj.setState({
                chenck:false,
                chencked:Util.returnEmptyAlone(params[0].data) === false ? false : true,
              });
            }
          }
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            color: "#878787",
            fontSize: 9,
            fontWeight: 600,
            data: _name,
            axisTick: {
              lineStyle: {
                width: 0,
              }
            },
            axisLabel: {
              color: "#878787",
              showMinLabel: true,
              showMaxLabel: true,
              interval: Math.ceil(_name.length / 2)-1,
              align: "center",
              margin:20,
              formatter:function(value,index){
                if(index === 0) {
                  return '        ' + value;
                }
                if(index === _name.length -1) {
                  return value + '         ';
                }
                return value
              }
            },
            axisLine: {
              show:true,
              onZero:false,
              lineStyle: {
                width: 1,
                color: "rgb(160,167,176,0.7)"
              }
            },
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            splitNumber: 3,
            axisLine: {
              lineStyle: {
                width: 0,
                color: "#878787"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                width: 0.5,
                color: "#DFDFDF",
                type: "dashed",
              },
            },
            axisTick: {
              lineStyle: {
                width: 0,
                color: "#9BC4D8"
              }
            },
            axisLabel: {
              formatter:function(value,index){
                return value.toFixed(2)+"%"
              },
              textStyle: {
                fontSize: 12
              }
            }
          }
        ]
      }
    return optionA
    } else{
      let optionA = {
        calculable: true,
        series: seriesArr,
        grid: {
          y: '10%',
          left: 70,
          bottom: 50,
          top: 60, //75
        },
        tooltip: {
          show: true,
          position: [15, 0],
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#F92C3D',
              width: 1,
              type: 'dashed'
            },
            label:{
              margin:20,
              show:true,
              backgroundColor:'#F92C3D'
            }
          },
          backgroundColor: "rgba(246, 247, 250, 1)",
          extraCssText: 'box-shadow: 0 0 0 rgba(0, 0, 0, 0.3)',
          textStyle: { fontSize: 12 },
          formatter: function(params){
            _this.setState({
              newNevs: Util.returnEmptyAlone(params[0].value) === false ? _this.state.newNev : params[0].value,//净值
              newDatas: Util.returnEmptyAlone(params[0].name) === false ? _this.state.newData : params[0].name,//日期
              
            })
            _this.props._thisObj.setState({
              chenck:false,
              chencked:Util.returnEmptyAlone(params[0].data) === false ? false : true,
            });
          }
        },
        xAxis: [
          {
            silent:false,
            type: 'category',
            boundaryGap: false,
            color: "#878787",
            fontSize: 9,
            fontWeight: 600,
            data: _name,
            axisTick: {
              lineStyle: {
                width: 0,
              }
            },
            axisLabel: {
              color: "#878787",
              showMinLabel: true,
              showMaxLabel: true,
              interval: Math.ceil(_name.length / 2)-1,
              align: "center",
              margin:20,
              formatter:function(value,index){
                if(index === 0) {
                  return '        ' + value;
                }
                if(index === _name.length -1) {
                  return value + '         ';
                }
                return value
              }
            },
            axisLine: {
              lineStyle: {
                width: 0.5,
                color: "rgb(160,167,176)"
              }
            },
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            splitNumber: 3,
            axisLine: {
              lineStyle: {
                width: 0,
                color: "#878787"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                width: 0.5,
                color: "#DFDFDF",
                type: "dashed",
              },
            },
            axisTick: {
              lineStyle: {
                width: 0,
                color: "#9BC4D8"
              }
            },
            axisLabel: {
              formatter:function(value,index){
                return value.toFixed(4)
              },
              textStyle: {
                fontSize: 12
              }
            }
          }
        ]
      }
    return optionA
    }
  }
  //业绩走势亏展示
  yingkui = () => {
    if (this.props._thisObj.state.tabVal == '业绩走势' && this.props._thisObj.state.chenck !== true) {
      return (
          <div style={{ zIndex: 1, height: 25, position: "absolute", top: 0, width: '100%',padding: 10,paddingLeft:5,paddingRight:5}}>
            {
              this.props._thisObj.state.publicFundPerformanceflag ?
                <div>
                  <div style={{ marginBottom:7,display: 'flex', width: '100%',alignItems: 'center' ,paddingLeft:20}}>
                    <div style={{ width: 160,display:'flex' ,justifyContent: "flex-start", alignItems: 'center' }}>
                      <div style={{width:6,height:6,backgroundColor:"#BF9B79",borderRadius:3}} ></div>
                      <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>本基金 :&nbsp;</div>
                      <div style={{ fontSize: 10, color: this.props.newNev < 0 ? '#139F6B' : this.props.newNev > 0 ? '#F92C3D' : '#666666' }}>{this.props.newNev != "--" ? this.props.newNev > 0.00 ? '+' + Util.fomatFloatpercentage(this.props.newNev) : Util.fomatFloatpercentage(this.props.newNev): '--'}</div>
                    </div>
                    <div onClick={()=>this.props.Basicback()} style={{width:125,display:'flex' ,alignItems: 'center'}}>
                      <div style={{width:6,height:6,backgroundColor:"#8EC7FF",borderRadius:3}} ></div>
                      <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>{this.props.Basictext} :&nbsp;</div>
                      <div style={{ fontSize: 10,  width:50,color: this.props.Lineval < 0 ? '#139F6B' : this.props.Lineval > 0 ? '#F92C3D' : '#666666' }}>{this.props.Lineval != "--" ? this.props.Lineval > 0.00 ? '+' + Util.fomatFloatpercentage(this.props.Lineval): Util.fomatFloatpercentage(this.props.Lineval): '--'}</div>
                      {this.props.Basicfalg ?
                        <img style={{width:12,height:12}} src={require('../../../imgs/icon／icon_shangjiantou_1414_999999.png')}/>
                        :
                        <img style={{width:12,height:12}} src={require('../../../imgs/icon_xiajiant.png')}/>
                      }
                    </div>
                  </div>
                  <div style={{paddingLeft:20,flex:1,display:'flex' ,alignItems: 'center',justifyContent: "flex-start"}}>
                    <div style={{width:6,height:6,backgroundColor:"#01D083",borderRadius:3}} ></div>
                    <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>最大回撤 : &nbsp;</div>
                    <div style={{ fontSize: 10, color: '#3C3C3C',fontWeight:"500" }}>-{Util.fomatFloatpercentage(this.props._thisObj.state.maxDrawDownValue)}</div>
                  </div>
                </div>
                
              :
                <div>
                  <div style={{ marginBottom:7,display: 'flex', width: '100%', justifyContent: "space-around",alignItems: 'center' ,paddingLeft:20}}>
                    <div style={{flex:1,display:'flex' ,justifyContent: "flex-start", alignItems: 'center' }}>
                      <div style={{width:6,height:6,backgroundColor:"#BF9B79",borderRadius:3}} ></div>
                      <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>本基金 :&nbsp;</div>
                      <div style={{ fontSize: 10, color: this.props.newNev < 0 ? '#139F6B' : this.props.newNev > 0 ? '#F92C3D' : '#666666' }}>{this.props.newNev != "--" ? this.props.newNev > 0.00 ? '+' + Util.fomatFloatpercentage(this.props.newNev): Util.fomatFloatpercentage(this.props.newNev): '--'}</div>
                    </div>
                    <div style={{flex:1,display:'flex' ,alignItems: 'center',justifyContent: "flex-start"}}>
                      <div style={{width:6,height:6,backgroundColor:"#BDC8D4",borderRadius:3}} >
                      </div>
                      <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>业绩基准 : &nbsp;</div>
                      <div style={{ fontSize: 10, color: this.props.allIncome < 0 ? '#139F6B' : this.props.allIncome > 0 ? '#F92C3D' : '#666666' }}>{this.props.allIncome != "--" ? this.props.allIncome > 0.00 ? '+' + Util.fomatFloatpercentage(this.props.allIncome): Util.fomatFloatpercentage(this.props.allIncome): '--'}</div>
                    </div>
                  </div>
                  <div style={{paddingLeft:20,display:'flex', width: '100%', justifyContent: "space-around",alignItems: 'center' }}>
                    <div onClick={()=>this.props.Basicback()} style={{flex:1,display:'flex' ,justifyContent: "flex-start", alignItems: 'center' }}>
                      <div style={{width:6,height:6,backgroundColor:"#8EC7FF",borderRadius:3}} ></div>
                      <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>{this.props.Basictext} :&nbsp;</div>
                      <div style={{ fontSize: 10,  width:50,color: this.props.Lineval < 0 ? '#139F6B' : this.props.Lineval > 0 ? '#F92C3D' : '#666666' }}>{this.props.Lineval != "--" ? this.props.Lineval > 0.00 ? '+' + Util.fomatFloatpercentage(this.props.Lineval): Util.fomatFloatpercentage(this.props.Lineval): '--'}</div>
                      {this.props.Basicfalg ?
                        <img style={{width:12,height:12}} src={require('../../../imgs/icon／icon_shangjiantou_1414_999999.png')}/>
                        :
                        <img style={{width:12,height:12}} src={require('../../../imgs/icon_xiajiant.png')}/>
                      }
                    </div>
                    <div style={{flex:1,display:'flex' ,alignItems: 'center',justifyContent: "flex-start"}}>
                      <div style={{width:6,height:6,backgroundColor:"#01D083",borderRadius:3}} ></div>
                      <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>最大回撤 : &nbsp;</div>
                      <div style={{ fontSize: 10,color: '#3C3C3C',fontWeight:"500"}}>-{Util.fomatFloatpercentage(this.props._thisObj.state.maxDrawDownValue)}</div>
                    </div>
                  </div>
                </div>
            }
          </div>
        )
    } else {
      return (
        <div style={{ zIndex: 1, height: 25, position: "absolute", top: 0, width: '100%',padding: 10,paddingLeft:5,paddingRight:5}}>
          {
            this.props._thisObj.state.publicFundPerformanceflag ?
            <div>
              <div style={{ marginBottom:7,display: 'flex', width: '100%',alignItems: 'center' ,paddingLeft:20}}>
                <div style={{ width: 160,display:'flex' ,justifyContent: "flex-start", alignItems: 'center' }}>
                  <div style={{width:6,height:6,backgroundColor:"#BF9B79",borderRadius:3}} ></div>
                  <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>本基金 :&nbsp;</div>
                  <div style={{ fontSize: 10, color: this.state.newNev < 0 ? '#139F6B' : this.state.newNev > 0 ? '#F92C3D' : '#666666' }}>{this.state.newNev !='--' ? this.state.newNev > 0.00 ? '+' + this.state.newNev + "%": this.state.newNev+ "%" : '--'}</div>
                </div>
                <div onClick={()=>this.props.Basicback()} style={{ width: 125,display:'flex' ,alignItems: 'center'}}>
                    <div style={{width:6,height:6,backgroundColor:"#8EC7FF",borderRadius:3}} ></div>
                    <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>{this.props.Basictext} :&nbsp;</div>
                    <div style={{ fontSize: 10,  width:50,color: this.state.Lineval < 0 ? '#139F6B' : this.state.Lineval > 0 ? '#F92C3D' : '#666666' }}>{this.state.Lineval !='--' ? this.state.Lineval > 0.00 ? '+' + this.state.Lineval+ "%" : this.state.Lineval+ "%" : '--'}</div>
                    {this.props.Basicfalg ?
                      <img style={{width:12,height:12}} src={require('../../../imgs/icon／icon_shangjiantou_1414_999999.png')}/>
                      :
                      <img style={{width:12,height:12}} src={require('../../../imgs/icon_xiajiant.png')}/>
                    }
                  </div>
              </div>
              {
                this.props._thisObj.state.Notenoughforoneyear !== -1 ?
                  <div style={{paddingLeft:20,flex:1,display:'flex' ,alignItems: 'center',justifyContent: "flex-start"}}>
                    <div style={{width:6,height:6,backgroundColor:"#01D083",borderRadius:3}} ></div>
                    <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>最大回撤 : &nbsp;</div>
                    <div style={{ fontSize: 10,color: '#3C3C3C',fontWeight:"500"}}>-{Util.fomatFloatpercentage(this.props._thisObj.state.maxDrawDownValue)}</div>
                  </div>
                :
                  null
              }
            </div>
            
          :
            <div>
              <div style={{ marginBottom:7,display: 'flex', width: '100%', justifyContent: "space-around",alignItems: 'center' ,paddingLeft:20}}>
                <div style={{flex:1,display:'flex' ,justifyContent: "flex-start", alignItems: 'center' }}>
                  <div style={{width:6,height:6,backgroundColor:"#BF9B79",borderRadius:3}} ></div>
                  <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>本基金 :&nbsp;</div>
                  <div style={{ fontSize: 10, color: this.state.newNev < 0 ? '#139F6B' : this.state.newNev > 0 ? '#F92C3D' : '#666666' }}>{this.state.newNev !='--' ? this.state.newNev > 0.00 ? '+' + this.state.newNev + "%": this.state.newNev+ "%" : '--'}</div>
                </div>
                <div style={{flex:1,display:'flex' ,alignItems: 'center',justifyContent: "flex-start"}}>
                  <div style={{width:6,height:6,backgroundColor:"#BDC8D4",borderRadius:3}} >
                  </div>
                  <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>业绩基准 : &nbsp;</div>
                  <div style={{ fontSize: 10, color: this.state.allIncome < 0 ? '#139F6B' : this.state.allIncome > 0 ? '#F92C3D' : '#666666' }}>{this.state.allIncome !='--' ? this.state.allIncome > 0.00 ? '+' + this.state.allIncome+ "%" : this.state.allIncome+ "%" : '--'}</div>
                </div>
              </div>
              <div style={{paddingLeft:20,display:'flex', width: '100%', justifyContent: "space-around",alignItems: 'center' }}>
                <div onClick={()=>this.props.Basicback()} style={{flex:1,display:'flex' ,justifyContent: "flex-start", alignItems: 'center' }}>
                  <div style={{width:6,height:6,backgroundColor:"#8EC7FF",borderRadius:3}} ></div>
                  <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>{this.props.Basictext} :&nbsp;</div>
                  <div style={{ fontSize: 10, width:50,color: this.state.Lineval < 0 ? '#139F6B' : this.state.Lineval > 0 ? '#F92C3D' : '#666666' }}>{this.state.Lineval !='--' ? this.state.Lineval > 0.00 ? '+' + this.state.Lineval+ "%" : this.state.Lineval+ "%" : '--'}</div>
                  {this.props.Basicfalg ?
                    <img style={{width:12,height:12}} src={require('../../../imgs/icon／icon_shangjiantou_1414_999999.png')}/>
                    :
                    <img style={{width:12,height:12}} src={require('../../../imgs/icon_xiajiant.png')}/>
                  }
                </div>
                {
                  this.props._thisObj.state.Notenoughforoneyear !== -1 ?
                    <div style={{paddingLeft:20,flex:1,display:'flex' ,alignItems: 'center',justifyContent: "flex-start"}}>
                      <div style={{width:6,height:6,backgroundColor:"#01D083",borderRadius:3}} ></div>
                      <div style={{ fontSize: 10, color: '#3C3C3C', marginLeft: 1 }}>最大回撤 : &nbsp;</div>
                      <div style={{ fontSize: 10,color: '#3C3C3C',fontWeight:"500"}}>-{Util.fomatFloatpercentage(this.props._thisObj.state.maxDrawDownValue)}</div>
                    </div>
                  :
                    <div></div>
                }
              </div>
            </div>
          }
        </div>
      )
    }
  }
  //单位和累计净值展示
  othertips = () => {
    if (this.props._thisObj.state.tabVal !== '业绩走势' && this.props._thisObj.state.chencked !== true) {
      return (
        <div style={{ zIndex: 1,paddingLeft:22,paddingRight:22,paddingTop:10,paddingBottom:10, display: 'flex', justifyContent: 'space-between', height: 25,  position: "absolute", top: 5,left:0,width: '100%', alignItems: 'center'}}>
          <div style={{ display: 'flex', width: 160, justifyContent: 'flex-start',  alignItems: 'center',}}><div style={{ fontSize: 12, color: '#3C3C3C' }}> 日期 : {this.props.newDatas !='--' ? this.props.newDatas : '--'}</div></div>
          <div style={{ display: 'flex',width:125,justifyContent: 'flex-start',  alignItems: 'center'}}>
            <div style={{ fontSize: 12, color: '#3C3C3C', marginLeft: 3 }}>{this.props._tabVal == '业绩走势' ? '本基金' : this.props._tabVal + ' : '}</div>
            {this.props._tabVal == '七日年化' ?
            <div style={{ fontSize: 12, color: this.props.newNevs < 0 ? '#139F6B' : this.props.newNevs > 0 ? '#F92C3D' : '#666666' }}>{this.props.newNevs > 0 ? this.props.newNevs + "%" : this.props.newNevs }</div>
            :
            <div style={{ fontSize: 12, color: '#666666' }}>{Util.Retainfourdecimalplaces(this.props.newNevs)||'--'}</div>
            }
          </div>
        </div>
      )
    } else {
      return (
        <div style={{ zIndex: 1,paddingLeft:22,paddingRight:22,paddingTop:10,paddingBottom:10, display: 'flex', justifyContent: 'space-between', height: 25,  position: "absolute", top: 5,left:0,width: '100%', alignItems: 'center'}}>
          <div style={{ display: 'flex', width: 160, justifyContent: 'flex-start',  alignItems: 'center'}}><div style={{ fontSize: 12, color: '#3C3C3C' }}> 日期 : {this.state.newDatas !='--' ? this.state.newDatas : '--'}</div></div>
          <div style={{ display: 'flex',width:125,justifyContent: 'flex-start',  alignItems: 'center'}}>
            <div style={{ fontSize: 12, color: '#3C3C3C', marginLeft: 3 }}>{this.props._tabVal == '业绩走势' ? '本基金' : this.props._tabVal + ' : '}</div>
            {
              this.props._tabVal == '七日年化' ?
                <div style={{ fontSize: 12, color: this.state.newNevs < 0 ? '#139F6B' : this.state.newNevs > 0 ? '#F92C3D' : '#666666' }}>
                  {this.state.newNevs !='--' ? this.state.newNevs +'%': '--'}
                </div>
              :
                <div style={{ fontSize: 12, color: '#666666' }}>{Util.Retainfourdecimalplaces(this.state.newNevs)||'--'}</div>
            }
          </div>
        </div>
      )
    }
  }
  render() {
    return (
      <div style={{display:'flex' ,justifyContent: "center", alignItems: "center", flex: 1, position:'relative'}}>
        <div style={{display:'flex' ,justifyContent: "center", alignItems: "center", flex: 1}}>
        {
          this.props._tabVal == '业绩走势' ? 
            this.props._thisObj.state.lineOption1 ? 
              this.yingkui() 
            : 
              null 
          : 
            this.props._thisObj.state.lineOption ? 
              this.othertips()
            : 
              null
        }
        <div id='PublicLine' style={{ width: '100%', height: 300, overflow: "hidden" }} />
        {
          this.state._value.length>0?
            null
          :
            <div style={{ display:'flex',justifyContent:'center',flexDirection:'column',alignItems:'center',width: '100%', height: 220, background:'#fff',position:'absolute',top:55}}>
              <img alt='' style={{marginBottom:10}} src={require('../../../imgs/zcdt_nonedata.png')} />
              <div style={{fontSize:12,color:'#666'}}>暂无数据</div>
            </div>
        }
        </div>
      </div>
    )
  }
}

export class SelectOtherTransRecord extends Component{
  constructor(props){
    super(props);
    this.state = {
    }
  }
  componentWillMount(){
    // Keyboard.dismiss();
  }
  componentDidMount(){
  }
  render(){
    let chenli=this.props.chengli
    let currentvalue=this.props.symbolvalue === "成立以来" ? this.props.symbolvalue+"("+chenli+")" :this.props.symbolvalue
    let listContent = this.props.listContent;
    let title = this.props.title;
    let listArray = [];
    for(let i = 0 ; i < listContent.length; i++){
      listArray.push(
        <div key={i + ''} onClick={() => listContent[i].callback()} style={{ borderBottom:'1px solid #EFF0F4', paddingTop: 20, paddingBottom: 20, marginLeft: 20, marginRight: 20,display:'flex',alignItems:"center",justifyContent: 'center' }}>
          <div style={{ fontSize: 14, lineHeight: '20px', color:currentvalue === listContent[i].title ?  "#F92C3D":'#333', fontWeight: '500' }}>{listContent[i].title}</div>
        </div>
      )
    }
    return (
      <div style = {styles.container1}>
        <div style = {{flex:1}}  onClick = {this.props.cancelCallback}>
          <div style={{flex:1}}></div>
        </div>
      <div style = {{...styles.actionContainer,height:300,backgroundColor:'#fff',bottom:0}}>
          {
            listArray
          }
          <div style={{flex:1,height:10,backgroundColor:"#F5F6F7"}}></div>
          <div onClick={this.props.cancelCallback} style={{height:50,display:'flex',paddingLeft:20,paddingRight:20,paddingTop:15}}>
            <div style={{color:'#666',fontSize:14,lineHeight:'20px',flex:1,textAlign:'center'}}>{title}</div>
          </div>
        </div>
      </div>
    );
  }
}
export class SelectOtherzhishu extends Component{
  constructor(props){
    super(props);
    this.state = {
    }
  }
  componentWillMount(){
    // Keyboard.dismiss();
  }
  componentDidMount(){
  }
  render(){
    let currentcode=this.props.symbolcode
    let listContent = this.props.listContent;
    let title = this.props.title;
    let listArray = [];
    for(let i = 0 ; i < listContent.length; i++){
      listArray.push(
        <div key={i + ''} onClick={() =>listContent[i].callback()} style={{ borderBottom:'1px solid #EFF0F4', paddingTop: 20, paddingBottom: 20, marginLeft: 20, marginRight: 20,display:'flex',alignItems:"center",justifyContent: 'center' }}>
          <div style={{ fontSize: 14, lineHeight: '20px', color:currentcode === listContent[i].code ?  "#F92C3D":'#333', fontWeight: '500' }}>{listContent[i].title}</div>
        </div>
      )
    }
    return (
      <div style = {styles.container1}>
        <div style = {{flex:1}}  onClick = {this.props.cancelCallback}>
          <div style={{flex:1}}></div>
        </div>
        <div style = {{...styles.actionContainer, backgroundColor:"#ffff",height:490}}>
          {
            listArray
          }
          <div style={{flex:1,height:10,backgroundColor:"#F5F6F7"}}></div>
          <div onClick={this.props.cancelCallback} style={{height:50,display:'flex',paddingLeft:20,paddingRight:20,alignItems:'center'}}>
            <div style={{color:'#666',fontSize:14,lineHeight:'20px',flex:1,textAlign:'center'}}>{title}</div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  actionContainer: {
    position: 'absolute',
    bottom: 0,
    width:'100%',
  }, 
  container1: {
    position: 'absolute',
    width: '100%',
    bottom: 0,
    top:0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 99998,
  },
  box:{
    paddingTop:15,
    paddingLeft:20,
    paddingRight:20,
    paddingBottom:15,
    background: '#fff'
  },
  b1:{
    fontSize:16,
    fontWeight:500,
    color:'#333',
  },
  b2:{
    fontSize:14,
    color:'#333'
  },
  activeLine:{
    background:'#F92C3D'
  },
  notActiveLine:{
    background:'#fff'
  },
  font12999:{
    fontSize:12,
    color:'#999'
  },
  font14119:{
    fontSize:14,
    color:'#985119'
  },
  font12119:{
    fontSize:12,
    color:'#985119'
  },
  font12666:{
    fontSize:12,
    color:'#666'
  },
  font14666:{
    fontSize:14,
    color:'#666'
  },
  font16333:{
    fontSize:16,
    color:'#333',
    fontWeight:500
  },
  redRound:{
    height:16,
    width:16,
    borderRadius:16,
    backgroundColor:'#F92C3D',
    border:'4px solid #FFE5E7',
  },
  footHeight: {
    alignSelf: 'stretch',
    flex:1,
    display:'flex',
    alignItems: 'center',
    width: 273,
    justifyContent:'center',
    borderColor: '#ebeef0',
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15
  },
  modalView: {
    backgroundColor: '#ffffff',
    borderRadius: 15,
    width: 273,
  },
  container2: {
    position: 'absolute',
    width: '100%',
    top: 0, 
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 999,
    justifyContent: 'center',
    alignItems: 'center',
    display:'flex'
  },
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(NewPublicOffering)



// WEBPACK FOOTER //
// ./src/components/product/Details/NewPublicOffering.js